// All UI strings for FR / EN / ZH. Keep flat keys for easy lookup.
export const translations = {
  fr: {
    // Nav
    "nav.home": "Accueil",
    "nav.services": "Services",
    "nav.sectors": "Secteurs",
    "nav.products": "Catalogue",
    "nav.about": "À propos",
    "nav.contact": "Contact",
    "nav.freight": "Fret",
    "nav.transfer": "Transfert d'argent",
    "nav.study": "Étudier en Chine",
    "nav.tracking": "Suivi colis",
    "nav.login": "Connexion",
    "nav.register": "Créer un compte",
    "nav.logout": "Déconnexion",
    "nav.dashboard": "Espace client",
    "nav.admin": "Admin",
    // Hero
    "home.kicker": "One-Stop Sourcing & Construction · Chine depuis 2012",
    "home.title1": "Votre projet.",
    "home.title2": "Notre expertise.",
    "home.title3": "Une solution complète.",
    "home.subtitle": "NEGOSINO est votre partenaire unique en Chine pour le sourcing multi-secteurs, la construction, la rénovation et la gestion de projet clé en main — de l'analyse jusqu'à la livraison finale.",
    "home.cta.quote": "Demander un devis",
    "home.cta.services": "Découvrir nos services",
    "home.stats.years": "années en Chine (depuis 2012)",
    "home.stats.offices": "bureaux : Yiwu & Guangzhou",
    "home.stats.sectors": "domaines d'expertise",
    // Services block on home
    "home.services.kicker": "Nos services",
    "home.services.title1": "Un partenaire.",
    "home.services.title2": "Toutes les étapes.",
    "home.services.desc": "De la planification à la livraison, NEGOSINO coordonne l'ensemble de vos projets grâce à un réseau solide de fournisseurs, fabricants et partenaires en Chine.",
    // Sectors block
    "home.sectors.kicker": "Domaines d'activité",
    "home.sectors.title": "Nous sourçons pour vous, partout en Chine.",
    "home.sectors.desc": "Quatre grandes familles couvertes par nos équipes de Yiwu et Guangzhou, avec un contrôle qualité systématique avant expédition.",
    "home.sectors.discover": "Découvrir",
    "sector.btp.t": "BTP, second œuvre & décoration",
    "sector.btp.d": "Matériaux, second œuvre, aménagements et projets de décoration pour vos chantiers résidentiels et commerciaux.",
    "sector.btp.long": "De la structure aux finitions, NEGOSINO source pour vous l'ensemble des matériaux et solutions techniques. Nous accompagnons les chantiers résidentiels, commerciaux et hôteliers avec une approche décoration soignée — du gros œuvre jusqu'à l'aménagement final.",
    "sector.btp.f1": "Matériaux de construction (carrelage, sanitaire, pierres)",
    "sector.btp.f2": "Menuiseries, portes, fenêtres, verre & aluminium",
    "sector.btp.f3": "Peintures, revêtements et éclairage architectural",
    "sector.btp.f4": "Aménagement intérieur et décoration sur-mesure",
    "sector.industrial.t": "Machines industrielles",
    "sector.industrial.d": "Équipements de production, lignes complètes, pièces détachées et machines-outils tous secteurs.",
    "sector.industrial.long": "NEGOSINO identifie et négocie pour vous les machines industrielles adaptées à votre activité — chez les meilleurs fabricants chinois. Nous prenons en charge la spécification technique, l'audit fabricant, l'essai de production et l'expédition sécurisée.",
    "sector.industrial.f1": "Lignes de production complètes et clés en main",
    "sector.industrial.f2": "Machines-outils (CNC, presses, découpe laser)",
    "sector.industrial.f3": "Équipements agro-alimentaires et emballage",
    "sector.industrial.f4": "Pièces détachées et service après-vente",
    "sector.vehicles.t": "Véhicules — camions & voitures",
    "sector.vehicles.d": "Toute la gamme : voitures particulières et camions, neufs et d'occasion. Marques chinoises et importations.",
    "sector.vehicles.long": "Nous vous accompagnons dans l'achat de véhicules — voitures particulières et camions — en Chine. Neufs ou d'occasion, chez les concessionnaires ou en direct usine. Vérification mécanique, papiers d'export, transport et dédouanement inclus.",
    "sector.vehicles.f1": "Voitures particulières neuves et d'occasion",
    "sector.vehicles.f2": "Camions : porteurs, semi-remorques, bennes, citernes",
    "sector.vehicles.f3": "Véhicules utilitaires et engins spéciaux",
    "sector.vehicles.f4": "Inspection mécanique et papiers d'export",
    "sector.furniture.t": "Mobilier & luminaires",
    "sector.furniture.d": "Mobilier maison, bureau, hôtellerie et restauration. Luminaires design, catalogue ou fabrication sur-mesure.",
    "sector.furniture.long": "De la table sur-mesure au lustre design, nous sourçons directement chez les fabricants et ateliers spécialisés de Guangzhou et Foshan. Contrôle des finitions, packaging renforcé pour l'export, service compris.",
    "sector.furniture.f1": "Mobilier maison, hôtel et restauration",
    "sector.furniture.f2": "Mobilier de bureau et open-space",
    "sector.furniture.f3": "Luminaires : suspensions, lampes, appliques",
    "sector.furniture.f4": "Fabrication sur-mesure et prototypage",
    // Sectors page
    "sectors.kicker": "Domaines d'activité",
    "sectors.title": "Quatre expertises. Une même exigence.",
    "sectors.desc": "Découvrez en détail chacun de nos domaines d'activité et les réalisations menées avec nos clients partout dans le monde.",
    "sectors.gallery": "Nos réalisations",
    "sectors.gallery.desc": "Aperçu de projets récents accompagnés par nos équipes.",
    "sectors.offers": "Ce que nous couvrons",
    "sectors.back": "Retour aux domaines",
    "sectors.cta.title": "Un projet dans ce domaine ?",
    "sectors.cta.desc": "Décrivez-le, nous revenons vers vous sous 48h avec une première estimation.",
    // About mini
    "home.about.kicker": "À propos",
    "home.about.title1": "En Chine depuis 2012.",
    "home.about.title2": "Deux bureaux, un seul interlocuteur.",
    "home.about.desc": "Implantée à Yiwu et Guangzhou, NEGOSINO accompagne des clients du monde entier dans leurs achats et projets en Chine. Notre approche One-Stop simplifie tout : un seul contact, du premier appel jusqu'à la livraison finale.",
    "home.about.stat1": "Un seul interlocuteur",
    "home.about.stat2": "Délai de réponse",
    "home.about.more": "En savoir plus",
    "home.about.tracking": "Suivi en temps réel de chaque étape — sourcing, production, contrôle qualité, expédition, livraison.",
    // Logistics band
    "home.logi.kicker": "Approche One-Stop",
    "home.logi.title": "De l'idée au chantier, sans le stress.",
    "home.logi.desc": "Nous coordonnons fournisseurs, production, logistique et chantier. Vous gardez la vision, nous gérons l'exécution.",
    "home.logi.cta": "Nous contacter",
    // Final CTA
    "home.cta.kicker": "Prêt à démarrer ?",
    "home.cta.title1": "Discutons de votre prochain",
    "home.cta.title2": "projet",
    "home.cta.contact": "Nous contacter",
    "home.cta.register": "Créer un compte client",
    // Services page (new — 3 core services + One-Stop)
    "services.kicker": "Nos services",
    "services.title": "Une équipe. Toutes les étapes de votre projet.",
    "services.desc": "NEGOSINO gère l'ensemble du cycle de votre projet — de la recherche de fournisseurs à la livraison sur site — grâce à ses équipes basées à Yiwu et Guangzhou.",
    "services.cta.title": "Un projet précis en tête ?",
    "services.cta.desc": "Décrivez-le, nous revenons vers vous sous 48h.",
    "services.cta.btn": "Demander un devis",
    "svc2.construction.t": "🏗️ Construction & développement de projets",
    "svc2.construction.d": "Construction résidentielle et commerciale, projets sur mesure, gestion complète des travaux, solutions adaptées aux exigences du client.",
    "svc2.renovation.t": "🔨 Rénovation & transformation",
    "svc2.renovation.d": "Rénovation complète d'espaces, modernisation de bâtiments, aménagement intérieur et extérieur, finitions personnalisées.",
    "svc2.onestop.t": "📋 Gestion de projet One-Stop",
    "svc2.onestop.d": "Analyse et préparation, solutions techniques, coordination des fournisseurs et équipes, suivi de production et de chantier, contrôle qualité, livraison finale.",
    "svc2.sourcing.t": "🌏 Sourcing multi-secteurs",
    "svc2.sourcing.d": "BTP, machines industrielles, automobile, camions, ameublement, quincaillerie — nous identifions et vérifions les fournisseurs adaptés à votre besoin.",
    "svc2.quality.t": "🛡️ Contrôle qualité",
    "svc2.quality.d": "Inspections avant chargement, rapports détaillés, photos et vidéos partagées en temps réel avant chaque expédition.",
    "svc2.logistics.t": "🚢 Logistique internationale",
    "svc2.logistics.d": "Maritime FCL/LCL, aérien, ferroviaire Chine-Europe. Dédouanement et livraison finale porte-à-porte.",
    // Why us
    "why.kicker": "Pourquoi NEGOSINO ?",
    "why.title": "Un savoir-faire construit sur le terrain.",
    "why.1.t": "12+ ans en Chine",
    "why.1.d": "Un savoir-faire développé depuis 2012 grâce à de nombreux projets menés à bien.",
    "why.2.t": "Un seul interlocuteur",
    "why.2.d": "Une gestion simplifiée, une équipe responsable de toutes les étapes du projet.",
    "why.3.t": "Présence directe en Chine",
    "why.3.d": "Nos bureaux de Yiwu et Guangzhou gèrent efficacement partenaires, fournisseurs et production.",
    "why.4.t": "Vision internationale",
    "why.4.d": "Communication claire et suivi personnalisé pour nos clients partout dans le monde.",
    // Products (kept for future e-commerce)
    "products.kicker": "Catalogue",
    "products.title1": "Lots sélectionnés.",
    "products.title2": "Prêts à expédier.",
    "products.desc": "Découvrez les lots actuellement disponibles. Pour toute demande personnalisée, contactez-nous.",
    "products.empty": "Aucun produit disponible pour le moment.",
    "products.from": "À partir de",
    "products.buy": "Acheter",
    "products.err": "Erreur lors de la création du paiement.",
    "products.rate": "taux indicatif",
    // About
    "about.kicker": "À propos",
    "about.title1": "Votre projet.",
    "about.title2": "Notre expertise.",
    "about.title3": "Une solution complète.",
    "about.p1": "NEGOSINO est votre partenaire unique pour tous vos projets de construction, rénovation, aménagement et sourcing en Chine. Avec plus de 12 années d'expérience depuis 2012, nous accompagnons nos clients avec une approche One-Stop, en prenant en charge chaque étape du projet, de la planification jusqu'à la réalisation finale.",
    "about.p2": "Implantée en Chine avec deux bureaux stratégiques à Yiwu et Guangzhou, NEGOSINO bénéficie d'un réseau solide de fournisseurs, fabricants et partenaires professionnels permettant de proposer des solutions fiables, compétitives et adaptées aux besoins de chaque client.",
    "about.p3": "Chez NEGOSINO, nous transformons vos idées en projets réalisés avec une approche basée sur la qualité, la fiabilité et la maîtrise des coûts. Notre équipe multilingue (mandarin, français, anglais) maîtrise les codes culturels, techniques et logistiques indispensables à la réussite de vos opérations en Chine.",
    "about.commitments": "Notre engagement",
    "about.c1.b": "Qualité & fiabilité.",
    "about.c1.t": "Contrôle systématique avant chaque expédition, aucune commission cachée.",
    "about.c2.b": "Maîtrise des coûts.",
    "about.c2.t": "Négociation ferme et transparence totale sur chaque poste de dépense.",
    "about.c3.b": "Réponse sous 48 heures.",
    "about.c3.t": "Toujours, même le week-end, dans la langue de votre choix.",
    // Contact
    "contact.kicker": "Contact",
    "contact.title": "Parlons de votre projet.",
    "contact.desc": "Décrivez-nous votre besoin — produit, volume, marché cible ou projet de construction. Notre équipe revient vers vous sous 48 heures avec une première estimation.",
    "contact.office.yiwu": "Bureau Yiwu",
    "contact.office.yiwu.addr": "Bureau 1517, China-Africa Building, No. J9 Chengda Avenue, Futian, Yiwu, Zhejiang, Chine",
    "contact.office.gz": "Bureau Guangzhou",
    "contact.office.gz.addr": "Unité C038, 5e-6e étage, No. 80-86 Xiwan Road, District de Liwan, Guangzhou, Guangdong, Chine",
    "contact.email": "Email",
    "contact.wa1": "WhatsApp — Ligne 1",
    "contact.wa2": "WhatsApp — Ligne 2",
    "contact.wa3": "WhatsApp — Ligne 3",
    "contact.wa.hint": "cliquez pour discuter",
    "contact.name": "Nom complet",
    "contact.emailFld": "Email",
    "contact.subject": "Sujet",
    "contact.message": "Votre message — produit, volume, marché cible, projet…",
    "contact.send": "Envoyer",
    "contact.sending": "Envoi…",
    "contact.success": "Message envoyé. Nous revenons vers vous très vite.",
    // Auth
    "auth.login.kicker": "Espace client",
    "auth.login.title": "Bon retour.",
    "auth.login.desc": "Connectez-vous à votre compte NEGOSINO.",
    "auth.login.submit": "Se connecter",
    "auth.login.loading": "Connexion…",
    "auth.login.noAccount": "Pas encore de compte ?",
    "auth.login.createAcc": "Créer un compte",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.register.kicker": "Nouveau compte",
    "auth.register.title": "Rejoignez NEGOSINO.",
    "auth.register.desc": "Suivi de vos demandes, devis et messages — au même endroit.",
    "auth.register.submit": "Créer mon compte",
    "auth.register.loading": "Création…",
    "auth.register.have": "Déjà inscrit ?",
    "auth.register.login": "Se connecter",
    "auth.name": "Nom complet",
    "auth.passwordMin": "Mot de passe (min 6)",
    // Dashboard
    "dash.kicker": "Espace client",
    "dash.welcome": "Bienvenue",
    "dash.desc": "Depuis cet espace, retrouvez vos demandes de devis, vos projets et toutes vos conversations avec notre équipe.",
    "dash.card1.t": "Nouvelle demande",
    "dash.card1.d": "Décrivez votre projet et recevez un devis sous 48h.",
    "dash.card2.t": "Catalogue",
    "dash.card2.d": "Découvrez les lots actuellement disponibles.",
    "dash.card3.t": "Discussion",
    "dash.card3.d": "Utilisez le chat en bas à droite pour parler à l'IA ou à notre équipe.",
    "dash.account": "Mon compte",
    "dash.role": "Rôle",
    // Footer
    "footer.about.kicker": "NEGOSINO",
    "footer.about.desc1": "One-Stop Construction & Sourcing Solutions — en Chine depuis 2012.",
    "footer.about.desc2": "Deux bureaux à Yiwu et Guangzhou. Un seul interlocuteur pour votre sourcing, votre construction et votre gestion de projet.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.rights": "Tous droits réservés.",
    "footer.tagline": "Votre projet. Notre expertise. Une solution complète.",
    "footer.follow": "Nous suivre",
    // Featured products (home)
    "featured.kicker": "Boutique en ligne",
    "featured.title": "Produits en stock, prêts à commander.",
    "featured.desc": "Une sélection de produits disponibles dans nos entrepôts de Yiwu et Guangzhou. Commandez en un clic.",
    "featured.see_all": "Voir tout le catalogue",
    "stock.in": "En stock",
    "stock.low": "Stock limité",
    "stock.out": "Rupture",
    "stock.senegal": "Stock Sénégal",
    "filter.all": "Toutes les catégories",
    "banner.promo": "🎁 -10% sur les couches bébé & adultes ce mois-ci — commande minimum 1 carton",
    "banner.cta": "Profiter de l'offre",
    // TikTok section
    "tiktok.kicker": "Sur TikTok",
    "tiktok.title": "Découvrez nos coulisses et nos projets en Chine.",
    "tiktok.desc": "Suivez notre quotidien à Yiwu et Guangzhou : visites d'usines, contrôles qualité, projets réalisés, coups de cœur.",
    "tiktok.video": "Vidéo",
    // Chat
    "chat.title.ai": "Sino · Assistant IA",
    "chat.title.support": "Support humain",
    "chat.header": "NEGOSINO · Discussion",
    "chat.tab.ai": "IA",
    "chat.tab.support": "Humain",
    "chat.placeholder.ai": "Posez votre question…",
    "chat.placeholder.support": "Votre message…",
    "chat.support.empty": "Envoyez votre message — notre équipe vous répond dès qu'elle est disponible.",
    "chat.hello": "Bonjour 👋 je suis Sino, l'assistant NEGOSINO. Comment puis-je vous aider avec votre projet en Chine ?",
    "chat.error": "Désolé, l'IA est temporairement indisponible.",
    // Language
    "lang.label": "Langue",
    // Payment
    "pay.success.title": "Paiement validé !",
    "pay.success.desc": "Un email de confirmation vous a été envoyé. Merci pour votre confiance.",
    "pay.expired.title": "Session expirée",
    "pay.expired.desc": "Veuillez réessayer le paiement.",
    "pay.checking": "Vérification du paiement…",
    "pay.back": "Retour au catalogue",
    "pay.cancel.title": "Paiement annulé",
    "pay.cancel.desc": "Aucune transaction n'a été effectuée. Vous pouvez réessayer à tout moment.",
    // Freight
    "freight.kicker": "Fret Chine → Sénégal",
    "freight.title": "Vos marchandises acheminées, suivies, livrées.",
    "freight.desc": "Depuis notre entrepôt de Yiwu, nous consolidons et expédions vos colis vers Dakar et le Sénégal — en fret normal ou express. Suivi en temps réel de bout en bout.",
    "freight.cta.quote": "Demander une cotation",
    "freight.cta.track": "Suivre un colis",
    "freight.services.title": "Trois formules adaptées à votre besoin",
    // Express
    "freight.express.badge": "Le plus rapide",
    "freight.express.title": "Fret express · Aérien",
    "freight.express.time": "3 à 5 jours",
    "freight.express.price": "12 000 FCFA / kg",
    "freight.express.price.hint": "≈ 18 € / kg",
    "freight.express.desc": "Idéal pour les urgences et les colis à forte valeur. Départ de Yiwu vers Dakar avec suivi étroit et notifications.",
    "freight.express.f1": "Prise en charge rapide à Yiwu",
    "freight.express.f2": "Suivi étroit et notifications",
    "freight.express.f3": "Idéal pour petits volumes urgents",
    // Normal
    "freight.normal.badge": "Standard",
    "freight.normal.title": "Fret normal · Aérien",
    "freight.normal.time": "10 à 15 jours",
    "freight.normal.price": "8 000 FCFA / kg",
    "freight.normal.price.hint": "≈ 12 € / kg",
    "freight.normal.desc": "Le meilleur rapport délai/prix pour vos envois réguliers. Départ de Yiwu vers Dakar.",
    "freight.normal.f1": "Bon compromis délai / tarif",
    "freight.normal.f2": "Consolidation possible avec d'autres clients",
    "freight.normal.f3": "Livraison Dakar incluse",
    // Maritime
    "freight.maritime.badge": "Économique",
    "freight.maritime.title": "Fret maritime · Container",
    "freight.maritime.time": "40 à 55 jours",
    "freight.maritime.price": "170 000 FCFA / m³",
    "freight.maritime.price.hint": "Produits normaux · ≈ 260 € / m³",
    "freight.maritime.desc": "La solution la plus économique pour les gros volumes. Départ depuis Yiwu et Guangzhou vers Dakar. Le prix au CBM peut varier selon la saison.",
    "freight.maritime.f1": "Consolidation 20/40 pieds",
    "freight.maritime.f2": "Départ Yiwu & Guangzhou",
    "freight.maritime.f3": "Douanes et livraison Dakar incluses",
    // What's included
    "freight.included": "Ce qui est inclus dans chaque formule",
    // Dakar pickup point
    "freight.pickup.kicker": "Retrait à Dakar",
    "freight.pickup.title": "Récupérez vos colis express à Dakar Mariste",
    "freight.pickup.desc": "Une fois arrivés à Dakar, vos colis express peuvent être récupérés directement à notre point de retrait à Dakar Mariste, entre la BICIS et la SGBS.",
    "freight.pickup.addr.label": "Adresse",
    "freight.pickup.addr": "Dakar Mariste — entre la banque BICIS et la banque SGBS",
    "freight.pickup.agent.label": "Agent Dakar",
    "freight.pickup.agent.hint": "Appelez notre agent pour organiser le retrait",
    "freight.pickup.map": "Voir sur la carte",
    "freight.pickup.directions": "Itinéraire Google Maps",
    "freight.pickup.call": "Appeler",
    "freight.pickup.whatsapp": "WhatsApp",
    "freight.i1": "Enlèvement à Yiwu",
    "freight.i2": "Contrôle et emballage export",
    "freight.i3": "Documentation et dédouanement",
    "freight.i4": "Suivi en temps réel via numéro NGS-XXXXXXXX",
    "freight.i5": "Livraison à Dakar (ou toute autre ville sur demande)",
    "freight.track.title": "Suivi de colis",
    "freight.track.desc": "Saisissez votre numéro de suivi (format NGS-XXXXXXXX) pour voir l'état de votre expédition en temps réel.",
    "freight.track.placeholder": "NGS-XXXXXXXX",
    "freight.track.btn": "Suivre",
    "freight.track.notfound": "Aucune expédition trouvée pour ce numéro.",
    "freight.track.summary": "Résumé",
    "freight.track.timeline": "Historique",
    "freight.track.service": "Type de service",
    "freight.track.origin": "Origine",
    "freight.track.dest": "Destination",
    "freight.track.eta": "Livraison estimée",
    "freight.track.weight": "Poids",
    "freight.track.volume": "Volume",
    "freight.track.description": "Contenu",
    "freight.track.status": "Statut actuel",
    // Statuses
    "status.created": "Enregistré",
    "status.picked_up": "Récupéré à Yiwu",
    "status.in_transit_china": "En transit en Chine",
    "status.in_transit": "En transit international",
    "status.arrived_port": "Arrivé au port/aéroport",
    "status.customs_clearance": "Dédouanement",
    "status.out_for_delivery": "En cours de livraison",
    "status.delivered": "Livré",
    "status.exception": "Incident",
  },

  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.sectors": "Sectors",
    "nav.products": "Catalog",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.freight": "Freight",
    "nav.transfer": "Money transfer",
    "nav.study": "Study in China",
    "nav.tracking": "Tracking",
    "nav.register": "Create account",
    "nav.logout": "Logout",
    "nav.dashboard": "My account",
    "nav.admin": "Admin",

    "home.kicker": "One-Stop Sourcing & Construction · In China since 2012",
    "home.title1": "Your project.",
    "home.title2": "Our expertise.",
    "home.title3": "A complete solution.",
    "home.subtitle": "NEGOSINO is your single partner in China for multi-sector sourcing, construction, renovation and turnkey project management — from analysis to final delivery.",
    "home.cta.quote": "Request a quote",
    "home.cta.services": "See our services",
    "home.stats.years": "years in China (since 2012)",
    "home.stats.offices": "offices: Yiwu & Guangzhou",
    "home.stats.sectors": "areas of expertise",

    "home.services.kicker": "Our services",
    "home.services.title1": "One partner.",
    "home.services.title2": "Every step.",
    "home.services.desc": "From planning to delivery, NEGOSINO coordinates your entire project through a solid network of suppliers, manufacturers and partners across China.",

    "home.sectors.kicker": "Areas of expertise",
    "home.sectors.title": "We source for you, everywhere in China.",
    "home.sectors.desc": "Four major families covered by our teams in Yiwu and Guangzhou, with systematic pre-shipment quality control.",
    "home.sectors.discover": "Discover",
    "sector.btp.t": "Construction, fit-out & interior design",
    "sector.btp.d": "Materials, finishing works, fit-out and interior design for your residential and commercial projects.",
    "sector.btp.long": "From structure to finishes, NEGOSINO sources all your materials and technical solutions. We support residential, commercial and hospitality projects with a refined interior-design approach — from shell to final fit-out.",
    "sector.btp.f1": "Building materials (tiles, sanitary ware, stones)",
    "sector.btp.f2": "Joinery, doors, windows, glass & aluminium",
    "sector.btp.f3": "Paints, coverings and architectural lighting",
    "sector.btp.f4": "Custom interior design and fit-out",
    "sector.industrial.t": "Industrial machinery",
    "sector.industrial.d": "Production equipment, complete lines, spare parts and machine tools across all industries.",
    "sector.industrial.long": "NEGOSINO identifies and negotiates industrial machinery tailored to your activity — with the best Chinese manufacturers. We handle technical specification, factory audit, production trial and secured shipping.",
    "sector.industrial.f1": "Complete turnkey production lines",
    "sector.industrial.f2": "Machine tools (CNC, presses, laser cutting)",
    "sector.industrial.f3": "Food-processing and packaging equipment",
    "sector.industrial.f4": "Spare parts and after-sales service",
    "sector.vehicles.t": "Vehicles — trucks & cars",
    "sector.vehicles.d": "Full range: passenger cars and trucks, new and used. Chinese brands and imported vehicles.",
    "sector.vehicles.long": "We support you in purchasing vehicles — passenger cars and trucks — in China. New or used, from dealerships or direct from the factory. Mechanical checks, export paperwork, transport and customs clearance included.",
    "sector.vehicles.f1": "Passenger cars, new and used",
    "sector.vehicles.f2": "Trucks: rigid, semi-trailers, dumpers, tankers",
    "sector.vehicles.f3": "Utility and special-purpose vehicles",
    "sector.vehicles.f4": "Mechanical inspection and export paperwork",
    "sector.furniture.t": "Furniture & lighting",
    "sector.furniture.d": "Home, office, hospitality and restaurant furniture. Design lighting — catalog or custom manufacturing.",
    "sector.furniture.long": "From a custom-made table to a designer chandelier, we source directly from manufacturers and specialized workshops in Guangzhou and Foshan. Finish control, reinforced export packaging, all included.",
    "sector.furniture.f1": "Home, hotel and restaurant furniture",
    "sector.furniture.f2": "Office and open-space furniture",
    "sector.furniture.f3": "Lighting: pendants, lamps, wall sconces",
    "sector.furniture.f4": "Custom manufacturing and prototyping",

    "sectors.kicker": "Areas of expertise",
    "sectors.title": "Four expertises. One same standard.",
    "sectors.desc": "Explore each of our areas of expertise in detail and the projects delivered with our clients worldwide.",
    "sectors.gallery": "Our projects",
    "sectors.gallery.desc": "A glimpse of recent projects supported by our teams.",
    "sectors.offers": "What we cover",
    "sectors.back": "Back to sectors",
    "sectors.cta.title": "A project in this field?",
    "sectors.cta.desc": "Describe it, we get back to you within 48h with a first estimate.",

    "home.about.kicker": "About",
    "home.about.title1": "In China since 2012.",
    "home.about.title2": "Two offices, one contact.",
    "home.about.desc": "Based in Yiwu and Guangzhou, NEGOSINO supports clients worldwide on their purchases and projects in China. Our One-Stop approach makes it simple: one contact, from first call to final delivery.",
    "home.about.stat1": "Single point of contact",
    "home.about.stat2": "Response time",
    "home.about.more": "Learn more",
    "home.about.tracking": "Real-time tracking of every step — sourcing, production, quality control, shipping, delivery.",

    "home.logi.kicker": "One-Stop approach",
    "home.logi.title": "From idea to jobsite, stress-free.",
    "home.logi.desc": "We coordinate suppliers, production, logistics and construction. You keep the vision, we handle execution.",
    "home.logi.cta": "Contact us",

    "home.cta.kicker": "Ready to start?",
    "home.cta.title1": "Let's talk about your next",
    "home.cta.title2": "project",
    "home.cta.contact": "Contact us",
    "home.cta.register": "Create a client account",

    "services.kicker": "Our services",
    "services.title": "One team. Every step of your project.",
    "services.desc": "NEGOSINO manages the entire lifecycle of your project — from supplier research to on-site delivery — with teams based in Yiwu and Guangzhou.",
    "services.cta.title": "A specific project in mind?",
    "services.cta.desc": "Describe it, we get back to you within 48h.",
    "services.cta.btn": "Request a quote",
    "svc2.construction.t": "🏗️ Construction & project development",
    "svc2.construction.d": "Residential and commercial construction, custom projects, full project management, solutions tailored to client requirements.",
    "svc2.renovation.t": "🔨 Renovation & transformation",
    "svc2.renovation.d": "Full space renovation, building modernization, interior and exterior fit-out, custom finishes.",
    "svc2.onestop.t": "📋 One-Stop project management",
    "svc2.onestop.d": "Analysis and preparation, technical solutions, coordination of suppliers and teams, production and site monitoring, quality control, final delivery.",
    "svc2.sourcing.t": "🌏 Multi-sector sourcing",
    "svc2.sourcing.d": "Construction, industrial machinery, automotive, trucks, furniture, hardware — we identify and vet suppliers matching your needs.",
    "svc2.quality.t": "🛡️ Quality control",
    "svc2.quality.d": "Pre-shipment inspections, detailed reports, real-time photos and videos before every shipment.",
    "svc2.logistics.t": "🚢 International logistics",
    "svc2.logistics.d": "Sea FCL/LCL, air, China-Europe rail. Customs clearance and door-to-door final delivery.",

    "why.kicker": "Why NEGOSINO?",
    "why.title": "Expertise built on the ground.",
    "why.1.t": "12+ years in China",
    "why.1.d": "Know-how built since 2012 through many successfully delivered projects.",
    "why.2.t": "One point of contact",
    "why.2.d": "Simplified management with one team responsible for every project step.",
    "why.3.t": "Direct presence in China",
    "why.3.d": "Our Yiwu and Guangzhou offices efficiently manage partners, suppliers and production.",
    "why.4.t": "International mindset",
    "why.4.d": "Clear communication and personalized follow-up for our clients worldwide.",

    "products.kicker": "Catalog",
    "products.title1": "Curated lots.",
    "products.title2": "Ready to ship.",
    "products.desc": "Discover the lots currently available. For custom requests, contact us.",
    "products.empty": "No products available at the moment.",
    "products.from": "From",
    "products.buy": "Buy",
    "products.err": "Error while creating the payment.",
    "products.rate": "indicative rate",

    "about.kicker": "About",
    "about.title1": "Your project.",
    "about.title2": "Our expertise.",
    "about.title3": "A complete solution.",
    "about.p1": "NEGOSINO is your single partner for all your construction, renovation, fit-out and sourcing projects in China. With more than 12 years of experience since 2012, we support our clients with a One-Stop approach, handling every step from planning to final delivery.",
    "about.p2": "Based in China with two strategic offices in Yiwu and Guangzhou, NEGOSINO benefits from a solid network of suppliers, manufacturers and professional partners, allowing us to offer reliable, competitive solutions tailored to each client's needs.",
    "about.p3": "At NEGOSINO, we turn your ideas into delivered projects with an approach built on quality, reliability and cost control. Our multilingual team (Mandarin, French, English) masters the cultural, technical and logistical codes essential to succeed in China.",
    "about.commitments": "Our commitments",
    "about.c1.b": "Quality & reliability.",
    "about.c1.t": "Systematic control before every shipment, no hidden commissions.",
    "about.c2.b": "Cost control.",
    "about.c2.t": "Firm negotiation and full transparency on every expense line.",
    "about.c3.b": "Response within 48 hours.",
    "about.c3.t": "Always, even on weekends, in your preferred language.",

    "contact.kicker": "Contact",
    "contact.title": "Let's talk about your project.",
    "contact.desc": "Tell us your need — product, volume, target market or construction project. Our team gets back to you within 48 hours with a first estimate.",
    "contact.office.yiwu": "Yiwu office",
    "contact.office.yiwu.addr": "Room 1517, China-Africa Building, No. J9 Chengda Avenue, Futian, Yiwu, Zhejiang, China",
    "contact.office.gz": "Guangzhou office",
    "contact.office.gz.addr": "Unit C038, 5F-6F, No. 80-86 Xiwan Road, Liwan District, Guangzhou, Guangdong, China",
    "contact.email": "Email",
    "contact.wa1": "WhatsApp — Line 1",
    "contact.wa2": "WhatsApp — Line 2",
    "contact.wa3": "WhatsApp — Line 3",
    "contact.wa.hint": "click to chat",
    "contact.name": "Full name",
    "contact.emailFld": "Email",
    "contact.subject": "Subject",
    "contact.message": "Your message — product, volume, target market, project…",
    "contact.send": "Send",
    "contact.sending": "Sending…",
    "contact.success": "Message sent. We'll come back to you very soon.",

    "auth.login.kicker": "Client area",
    "auth.login.title": "Welcome back.",
    "auth.login.desc": "Log in to your NEGOSINO account.",
    "auth.login.submit": "Log in",
    "auth.login.loading": "Logging in…",
    "auth.login.noAccount": "No account yet?",
    "auth.login.createAcc": "Create an account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.register.kicker": "New account",
    "auth.register.title": "Join NEGOSINO.",
    "auth.register.desc": "Track your requests, quotes and messages — in one place.",
    "auth.register.submit": "Create my account",
    "auth.register.loading": "Creating…",
    "auth.register.have": "Already registered?",
    "auth.register.login": "Log in",
    "auth.name": "Full name",
    "auth.passwordMin": "Password (min 6)",

    "dash.kicker": "Client area",
    "dash.welcome": "Welcome",
    "dash.desc": "From this space, find your quote requests, projects and all your conversations with our team.",
    "dash.card1.t": "New request",
    "dash.card1.d": "Describe your project and get a quote within 48h.",
    "dash.card2.t": "Catalog",
    "dash.card2.d": "Discover the lots currently available.",
    "dash.card3.t": "Chat",
    "dash.card3.d": "Use the chat at the bottom right to talk to the AI or our team.",
    "dash.account": "My account",
    "dash.role": "Role",

    "footer.about.kicker": "NEGOSINO",
    "footer.about.desc1": "One-Stop Construction & Sourcing Solutions — in China since 2012.",
    "footer.about.desc2": "Two offices in Yiwu and Guangzhou. A single contact for your sourcing, construction and project management needs.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "footer.tagline": "Your project. Our expertise. A complete solution.",
    "footer.follow": "Follow us",
    "featured.kicker": "Online shop",
    "featured.title": "In-stock products, ready to order.",
    "featured.desc": "A curated selection of products available in our Yiwu and Guangzhou warehouses. One-click checkout.",
    "featured.see_all": "See the full catalog",
    "stock.in": "In stock",
    "stock.low": "Low stock",
    "stock.out": "Out of stock",
    "stock.senegal": "Senegal stock",
    "filter.all": "All categories",
    "banner.promo": "🎁 10% off baby & adult diapers this month — minimum 1 carton",
    "banner.cta": "Grab the offer",

    "tiktok.kicker": "On TikTok",
    "tiktok.title": "See our backstage and our projects in China.",
    "tiktok.desc": "Follow our daily life in Yiwu and Guangzhou: factory visits, quality checks, delivered projects, favorites.",
    "tiktok.video": "Video",

    "chat.title.ai": "Sino · AI Assistant",
    "chat.title.support": "Human support",
    "chat.header": "NEGOSINO · Chat",
    "chat.tab.ai": "AI",
    "chat.tab.support": "Human",
    "chat.placeholder.ai": "Ask your question…",
    "chat.placeholder.support": "Your message…",
    "chat.support.empty": "Send your message — our team will reply as soon as we're available.",
    "chat.hello": "Hello 👋 I'm Sino, the NEGOSINO assistant. How can I help with your project in China?",
    "chat.error": "Sorry, the AI is temporarily unavailable.",

    "lang.label": "Language",

    "pay.success.title": "Payment confirmed!",
    "pay.success.desc": "A confirmation email has been sent to you. Thank you for your trust.",
    "pay.expired.title": "Session expired",
    "pay.expired.desc": "Please try the payment again.",
    "pay.checking": "Verifying payment…",
    "pay.back": "Back to catalog",
    "pay.cancel.title": "Payment canceled",
    "pay.cancel.desc": "No transaction was made. You can try again at any time.",

    "freight.kicker": "Freight China → Senegal",
    "freight.title": "Your goods shipped, tracked, delivered.",
    "freight.desc": "From our Yiwu warehouse, we consolidate and ship your packages to Dakar and Senegal — via normal or express freight. Real-time tracking end to end.",
    "freight.cta.quote": "Request a quote",
    "freight.cta.track": "Track a package",
    "freight.services.title": "Three options tailored to your needs",
    "freight.express.badge": "Fastest",
    "freight.express.title": "Express freight · Air",
    "freight.express.time": "3 to 5 days",
    "freight.express.price": "12,000 FCFA / kg",
    "freight.express.price.hint": "≈ €18 / kg",
    "freight.express.desc": "Ideal for urgent shipments and high-value packages. Departs Yiwu to Dakar with close tracking and notifications.",
    "freight.express.f1": "Fast pickup in Yiwu",
    "freight.express.f2": "Close tracking with notifications",
    "freight.express.f3": "Perfect for small urgent volumes",
    "freight.normal.badge": "Standard",
    "freight.normal.title": "Normal freight · Air",
    "freight.normal.time": "10 to 15 days",
    "freight.normal.price": "8,000 FCFA / kg",
    "freight.normal.price.hint": "≈ €12 / kg",
    "freight.normal.desc": "The best time/price balance for your regular shipments. Departs Yiwu to Dakar.",
    "freight.normal.f1": "Great time / cost balance",
    "freight.normal.f2": "Consolidation with other clients possible",
    "freight.normal.f3": "Dakar delivery included",
    "freight.maritime.badge": "Cheapest",
    "freight.maritime.title": "Sea freight · Container",
    "freight.maritime.time": "40 to 55 days",
    "freight.maritime.price": "170,000 FCFA / m³",
    "freight.maritime.price.hint": "Standard cargo · ≈ €260 / m³",
    "freight.maritime.desc": "The most economical solution for large volumes. Departs from Yiwu and Guangzhou to Dakar. Per-CBM price may vary by season.",
    "freight.maritime.f1": "20/40-ft container consolidation",
    "freight.maritime.f2": "Departs Yiwu & Guangzhou",
    "freight.maritime.f3": "Dakar customs and delivery included",
    "freight.included": "What's included in every option",

    "freight.pickup.kicker": "Pickup in Dakar",
    "freight.pickup.title": "Collect your express packages at Dakar Mariste",
    "freight.pickup.desc": "Once arrived in Dakar, your express packages can be collected directly at our pickup point in Dakar Mariste, between BICIS bank and SGBS bank.",
    "freight.pickup.addr.label": "Address",
    "freight.pickup.addr": "Dakar Mariste — between BICIS bank and SGBS bank",
    "freight.pickup.agent.label": "Dakar agent",
    "freight.pickup.agent.hint": "Call our agent to arrange pickup",
    "freight.pickup.map": "View on map",
    "freight.pickup.directions": "Google Maps directions",
    "freight.pickup.call": "Call",
    "freight.pickup.whatsapp": "WhatsApp",
    "freight.i1": "Pickup in Yiwu",
    "freight.i2": "Inspection and export packaging",
    "freight.i3": "Documentation and customs clearance",
    "freight.i4": "Real-time tracking via NGS-XXXXXXXX number",
    "freight.i5": "Delivery in Dakar (or any other city on request)",
    "freight.track.title": "Package tracking",
    "freight.track.desc": "Enter your tracking number (format NGS-XXXXXXXX) to see your shipment status in real time.",
    "freight.track.placeholder": "NGS-XXXXXXXX",
    "freight.track.btn": "Track",
    "freight.track.notfound": "No shipment found for this tracking number.",
    "freight.track.summary": "Summary",
    "freight.track.timeline": "History",
    "freight.track.service": "Service type",
    "freight.track.origin": "Origin",
    "freight.track.dest": "Destination",
    "freight.track.eta": "Estimated delivery",
    "freight.track.weight": "Weight",
    "freight.track.volume": "Volume",
    "freight.track.description": "Contents",
    "freight.track.status": "Current status",

    "status.created": "Registered",
    "status.picked_up": "Picked up in Yiwu",
    "status.in_transit_china": "In transit in China",
    "status.in_transit": "International transit",
    "status.arrived_port": "Arrived at port/airport",
    "status.customs_clearance": "Customs clearance",
    "status.out_for_delivery": "Out for delivery",
    "status.delivered": "Delivered",
    "status.exception": "Exception",
  },

  zh: {
    "nav.home": "首页",
    "nav.services": "服务",
    "nav.sectors": "行业",
    "nav.products": "商品",
    "nav.about": "关于我们",
    "nav.contact": "联系",
    "nav.freight": "货运",
    "nav.transfer": "汇款服务",
    "nav.study": "留学中国",
    "nav.tracking": "包裹追踪",
    "nav.login": "登录",
    "nav.register": "创建账户",
    "nav.logout": "退出",
    "nav.dashboard": "我的账户",
    "nav.admin": "管理",

    "home.kicker": "一站式采购与工程 · 扎根中国 · 始于 2012",
    "home.title1": "您的项目。",
    "home.title2": "我们的专业。",
    "home.title3": "完整的解决方案。",
    "home.subtitle": "NEGOSINO 是您在中国的唯一合作伙伴,提供多行业采购、建筑施工、装修改造以及交钥匙项目管理——从分析到最终交付。",
    "home.cta.quote": "获取报价",
    "home.cta.services": "了解服务",
    "home.stats.years": "扎根中国(始于 2012)",
    "home.stats.offices": "办公室:义乌 & 广州",
    "home.stats.sectors": "专业领域",

    "home.services.kicker": "我们的服务",
    "home.services.title1": "同一个伙伴。",
    "home.services.title2": "每一个环节。",
    "home.services.desc": "从策划到交付,NEGOSINO 通过在中国建立的可靠供应商、制造商与合作伙伴网络,协调您项目的全过程。",

    "home.sectors.kicker": "业务领域",
    "home.sectors.title": "为您在中国采购,覆盖各地。",
    "home.sectors.desc": "四大产品家族由我们义乌与广州团队全面覆盖,每次发运前均执行严格质检。",
    "home.sectors.discover": "了解详情",
    "sector.btp.t": "建筑、装饰工程与室内设计",
    "sector.btp.d": "建材、装饰工程、布置与设计,服务于住宅与商业项目。",
    "sector.btp.long": "从主体结构到饰面细节,NEGOSINO 为您采购全部建材与技术方案。我们服务住宅、商业与酒店项目,以精致的室内设计思路,从毛坯直至最终落地。",
    "sector.btp.f1": "建材(瓷砖、卫浴、石材)",
    "sector.btp.f2": "门窗、玻璃与铝制品",
    "sector.btp.f3": "涂料、面材与建筑照明",
    "sector.btp.f4": "定制室内设计与装饰",
    "sector.industrial.t": "工业机械",
    "sector.industrial.d": "全行业生产设备、整线、备件与机床。",
    "sector.industrial.long": "NEGOSINO 在中国顶级制造商中为您甄选并谈判合适的工业机械。我们负责技术规格、工厂审核、生产试运行与安全发运。",
    "sector.industrial.f1": "整线交钥匙生产设备",
    "sector.industrial.f2": "机床(CNC、冲压、激光切割)",
    "sector.industrial.f3": "食品加工与包装设备",
    "sector.industrial.f4": "备件与售后服务",
    "sector.vehicles.t": "车辆 — 卡车与轿车",
    "sector.vehicles.d": "全系:乘用车与卡车,新车与二手车。国产品牌与进口车辆。",
    "sector.vehicles.long": "我们协助您在中国采购车辆——乘用车与卡车,新车或二手,来源于经销商或直接厂家。包含机械检查、出口证件、运输与清关。",
    "sector.vehicles.f1": "新车与二手乘用车",
    "sector.vehicles.f2": "卡车:载货车、半挂车、自卸车、罐车",
    "sector.vehicles.f3": "商用车与特种车辆",
    "sector.vehicles.f4": "机械检验与出口手续",
    "sector.furniture.t": "家具与照明",
    "sector.furniture.d": "家用、办公、酒店与餐饮家具。设计感照明——目录采购或定制生产。",
    "sector.furniture.long": "从定制家具到设计吊灯,我们直接在广州与佛山的制造商与专业工坊采购。饰面把控、加固出口包装,全部包含。",
    "sector.furniture.f1": "家用、酒店与餐饮家具",
    "sector.furniture.f2": "办公与开放空间家具",
    "sector.furniture.f3": "照明:吊灯、台灯、壁灯",
    "sector.furniture.f4": "定制生产与打样",

    "sectors.kicker": "业务领域",
    "sectors.title": "四大专长,同一标准。",
    "sectors.desc": "深入了解我们的每个业务领域,以及与全球客户共同完成的项目。",
    "sectors.gallery": "我们的项目",
    "sectors.gallery.desc": "近期由我们团队跟进项目的一瞥。",
    "sectors.offers": "我们覆盖的范围",
    "sectors.back": "返回业务领域",
    "sectors.cta.title": "该领域有项目?",
    "sectors.cta.desc": "描述您的需求,48 小时内我们将给出首次报价。",

    "home.about.kicker": "关于我们",
    "home.about.title1": "扎根中国,始于 2012。",
    "home.about.title2": "两个办公室,一位专属联系人。",
    "home.about.desc": "NEGOSINO 总部设于义乌与广州,为全球客户提供在中国的采购与项目服务。一站式方式让一切变得简单:从第一次沟通到最终交付,始终由同一位联系人跟进。",
    "home.about.stat1": "唯一联系人",
    "home.about.stat2": "回复时效",
    "home.about.more": "了解更多",
    "home.about.tracking": "每一步实时跟踪——采购、生产、质检、发运、交付。",

    "home.logi.kicker": "一站式方式",
    "home.logi.title": "从构思到工地,省心无忧。",
    "home.logi.desc": "我们协调供应商、生产、物流与工地。您专注决策,我们负责执行。",
    "home.logi.cta": "联系我们",

    "home.cta.kicker": "准备开始?",
    "home.cta.title1": "让我们聊聊您的下一个",
    "home.cta.title2": "项目",
    "home.cta.contact": "联系我们",
    "home.cta.register": "创建客户账户",

    "services.kicker": "我们的服务",
    "services.title": "一个团队,项目的每一个环节。",
    "services.desc": "NEGOSINO 由义乌与广州团队全程管理您的项目生命周期——从供应商搜寻到现场交付。",
    "services.cta.title": "已有具体项目?",
    "services.cta.desc": "描述给我们,48 小时内回复。",
    "services.cta.btn": "获取报价",
    "svc2.construction.t": "🏗️ 建筑与项目开发",
    "svc2.construction.d": "住宅与商业建筑、定制项目、全流程项目管理、贴合客户需求的解决方案。",
    "svc2.renovation.t": "🔨 装修与改造",
    "svc2.renovation.d": "空间整体翻新、建筑现代化改造、室内外布置、定制饰面。",
    "svc2.onestop.t": "📋 一站式项目管理",
    "svc2.onestop.d": "分析与准备、技术方案、供应商与团队协调、生产与现场跟进、质量控制、最终交付。",
    "svc2.sourcing.t": "🌏 多行业采购",
    "svc2.sourcing.d": "建筑、工业机械、汽车、卡车、家具、五金——我们为您识别并甄选合适供应商。",
    "svc2.quality.t": "🛡️ 质量控制",
    "svc2.quality.d": "发运前检验、详细报告、每次发运前实时共享照片与视频。",
    "svc2.logistics.t": "🚢 国际物流",
    "svc2.logistics.d": "海运整柜/拼箱、空运、中欧班列。含清关与门到门交付。",

    "why.kicker": "为什么选择 NEGOSINO?",
    "why.title": "在中国实战积累的专业。",
    "why.1.t": "深耕中国 12+ 年",
    "why.1.d": "自 2012 年起完成众多项目积累的专业能力。",
    "why.2.t": "一位专属联系人",
    "why.2.d": "简化管理,由同一团队负责所有环节。",
    "why.3.t": "扎根中国",
    "why.3.d": "义乌与广州办公室高效管理合作伙伴、供应商与生产。",
    "why.4.t": "国际视野",
    "why.4.d": "清晰沟通与个性化跟进,服务全球客户。",

    "products.kicker": "商品",
    "products.title1": "精选批次。",
    "products.title2": "即刻发运。",
    "products.desc": "查看当前可用批次。定制需求请联系我们。",
    "products.empty": "暂无可用商品。",
    "products.from": "起价",
    "products.buy": "购买",
    "products.err": "创建支付时出错。",
    "products.rate": "指示性汇率",

    "about.kicker": "关于我们",
    "about.title1": "您的项目。",
    "about.title2": "我们的专业。",
    "about.title3": "完整的解决方案。",
    "about.p1": "NEGOSINO 是您在中国的建筑、装修、布置与采购项目的唯一合作伙伴。自 2012 年起,凭借超过 12 年的经验,我们以一站式方式陪伴客户,从策划到最终交付,全程包办。",
    "about.p2": "NEGOSINO 在中国设有义乌与广州两处战略办公室,拥有可靠的供应商、制造商与专业合作伙伴网络,能为每位客户提供可靠、有竞争力且量身定制的解决方案。",
    "about.p3": "在 NEGOSINO,我们将您的想法转化为真正落地的项目,以质量、可靠性与成本控制为核心。多语言团队(中文、法语、英语)精通在中国成功运作所需的文化、技术与物流要点。",
    "about.commitments": "我们的承诺",
    "about.c1.b": "品质与可靠。",
    "about.c1.t": "每次发运前系统性质检,无隐性佣金。",
    "about.c2.b": "成本可控。",
    "about.c2.t": "坚定谈判,每一笔支出完全透明。",
    "about.c3.b": "48 小时内回复。",
    "about.c3.t": "始终如一,周末也不例外,支持您选择的语言。",

    "contact.kicker": "联系",
    "contact.title": "聊聊您的项目。",
    "contact.desc": "告诉我们您的需求——产品、数量、目标市场或建设项目。团队将在 48 小时内给您首次报价。",
    "contact.office.yiwu": "义乌办公室",
    "contact.office.yiwu.addr": "义乌市福田街道商城大道J9号中非大厦1517室",
    "contact.office.gz": "广州办公室",
    "contact.office.gz.addr": "广州市荔湾区西湾路80-86号5,6楼(自编六楼)C038",
    "contact.email": "电子邮箱",
    "contact.wa1": "WhatsApp — 线路 1",
    "contact.wa2": "WhatsApp — 线路 2",
    "contact.wa3": "WhatsApp — 线路 3",
    "contact.wa.hint": "点击开始聊天",
    "contact.name": "全名",
    "contact.emailFld": "邮箱",
    "contact.subject": "主题",
    "contact.message": "您的留言——产品、数量、目标市场、项目……",
    "contact.send": "发送",
    "contact.sending": "发送中…",
    "contact.success": "消息已发送。我们很快回复您。",

    "auth.login.kicker": "客户中心",
    "auth.login.title": "欢迎回来。",
    "auth.login.desc": "登录您的 NEGOSINO 账户。",
    "auth.login.submit": "登录",
    "auth.login.loading": "登录中…",
    "auth.login.noAccount": "还没有账户?",
    "auth.login.createAcc": "创建账户",
    "auth.email": "邮箱",
    "auth.password": "密码",
    "auth.register.kicker": "新账户",
    "auth.register.title": "加入 NEGOSINO。",
    "auth.register.desc": "请求、报价与消息——集中管理。",
    "auth.register.submit": "创建账户",
    "auth.register.loading": "创建中…",
    "auth.register.have": "已注册?",
    "auth.register.login": "登录",
    "auth.name": "全名",
    "auth.passwordMin": "密码(至少 6 位)",

    "dash.kicker": "客户中心",
    "dash.welcome": "欢迎",
    "dash.desc": "在这里查看您的报价请求、项目与团队的所有对话。",
    "dash.card1.t": "新请求",
    "dash.card1.d": "描述您的项目,48 小时内获得报价。",
    "dash.card2.t": "商品",
    "dash.card2.d": "查看当前可购买的批次。",
    "dash.card3.t": "对话",
    "dash.card3.d": "使用右下角的聊天与 AI 或我们的团队交流。",
    "dash.account": "我的账户",
    "dash.role": "角色",

    "footer.about.kicker": "NEGOSINO",
    "footer.about.desc1": "一站式建筑与采购解决方案——扎根中国,始于 2012。",
    "footer.about.desc2": "义乌与广州两处办公室。为您的采购、建设与项目管理提供唯一联系人。",
    "footer.nav": "导航",
    "footer.contact": "联系",
    "footer.rights": "版权所有。",
    "footer.tagline": "您的项目。我们的专业。完整的解决方案。",
    "footer.follow": "关注我们",
    "featured.kicker": "在线商店",
    "featured.title": "现货产品,即刻下单。",
    "featured.desc": "由我们义乌与广州仓库精选的现货商品。一键下单。",
    "featured.see_all": "查看完整商品目录",
    "stock.in": "有货",
    "stock.low": "库存有限",
    "stock.out": "缺货",
    "stock.senegal": "塞内加尔有货",
    "filter.all": "全部分类",
    "banner.promo": "🎁 本月婴儿与成人纸尿裤 9 折 — 最低 1 箱起订",
    "banner.cta": "享受优惠",

    "tiktok.kicker": "TikTok",
    "tiktok.title": "看看我们在中国的幕后与项目。",
    "tiktok.desc": "关注我们在义乌与广州的日常:工厂参观、质检、已完成项目、精选推荐。",
    "tiktok.video": "视频",

    "chat.title.ai": "Sino · AI 助手",
    "chat.title.support": "人工客服",
    "chat.header": "NEGOSINO · 聊天",
    "chat.tab.ai": "AI",
    "chat.tab.support": "人工",
    "chat.placeholder.ai": "请输入您的问题…",
    "chat.placeholder.support": "您的消息…",
    "chat.support.empty": "发送消息——我们会尽快回复您。",
    "chat.hello": "您好 👋 我是 NEGOSINO 的助手 Sino。您的中国项目我能怎么帮您?",
    "chat.error": "抱歉,AI 暂时不可用。",

    "lang.label": "语言",

    "pay.success.title": "付款成功!",
    "pay.success.desc": "确认邮件已发送。感谢您的信任。",
    "pay.expired.title": "会话已过期",
    "pay.expired.desc": "请重新尝试付款。",
    "pay.checking": "正在核对付款…",
    "pay.back": "返回商品",
    "pay.cancel.title": "付款已取消",
    "pay.cancel.desc": "未产生任何交易。您可以随时重试。",

    "freight.kicker": "货运 中国 → 塞内加尔",
    "freight.title": "货物运输、追踪与交付。",
    "freight.desc": "我们在义乌仓库为您集货并发运至达喀尔及塞内加尔——普通或加急货运,全程实时追踪。",
    "freight.cta.quote": "获取报价",
    "freight.cta.track": "追踪包裹",
    "freight.services.title": "三种方案匹配您的需求",
    "freight.express.badge": "最快",
    "freight.express.title": "空运加急",
    "freight.express.time": "3 至 5 天",
    "freight.express.price": "12,000 西非法郎 / 公斤",
    "freight.express.price.hint": "约 €18 / 公斤",
    "freight.express.desc": "适合紧急发运与高价值货物。义乌至达喀尔,全程紧密追踪与通知。",
    "freight.express.f1": "义乌快速上门取件",
    "freight.express.f2": "紧密追踪与通知",
    "freight.express.f3": "适合小体积紧急发运",
    "freight.normal.badge": "标准",
    "freight.normal.title": "空运普通",
    "freight.normal.time": "10 至 15 天",
    "freight.normal.price": "8,000 西非法郎 / 公斤",
    "freight.normal.price.hint": "约 €12 / 公斤",
    "freight.normal.desc": "时效与价格的最佳平衡,适合日常发运。义乌至达喀尔。",
    "freight.normal.f1": "时效与成本最佳平衡",
    "freight.normal.f2": "可与其他客户拼货",
    "freight.normal.f3": "含达喀尔派送",
    "freight.maritime.badge": "最经济",
    "freight.maritime.title": "海运 · 集装箱",
    "freight.maritime.time": "40 至 55 天",
    "freight.maritime.price": "170,000 西非法郎 / 立方米",
    "freight.maritime.price.hint": "约 €260 / 立方米 · 参考价",
    "freight.maritime.desc": "大宗货量最经济方案。从义乌与广州出发至达喀尔。立方米价格可能因季节而变化。",
    "freight.maritime.f1": "20/40 尺柜拼柜",
    "freight.maritime.f2": "义乌与广州出发",
    "freight.maritime.f3": "含达喀尔清关与派送",
    "freight.included": "每种方案均包含",

    "freight.pickup.kicker": "达喀尔提货",
    "freight.pickup.title": "在达喀尔 Mariste 领取您的加急货物",
    "freight.pickup.desc": "抵达达喀尔后,您的加急包裹可直接在我们位于 Dakar Mariste 的提货点领取,位于 BICIS 银行与 SGBS 银行之间。",
    "freight.pickup.addr.label": "地址",
    "freight.pickup.addr": "Dakar Mariste — BICIS 银行与 SGBS 银行之间",
    "freight.pickup.agent.label": "达喀尔代理",
    "freight.pickup.agent.hint": "致电我们的代理安排取件",
    "freight.pickup.map": "在地图上查看",
    "freight.pickup.directions": "谷歌地图导航",
    "freight.pickup.call": "致电",
    "freight.pickup.whatsapp": "WhatsApp",
    "freight.i1": "义乌上门取件",
    "freight.i2": "检验与出口包装",
    "freight.i3": "报关文件与清关",
    "freight.i4": "通过 NGS-XXXXXXXX 号码实时追踪",
    "freight.i5": "达喀尔派送(其他城市可议)",
    "freight.track.title": "包裹追踪",
    "freight.track.desc": "输入您的追踪号(格式 NGS-XXXXXXXX)即可实时查看货物状态。",
    "freight.track.placeholder": "NGS-XXXXXXXX",
    "freight.track.btn": "追踪",
    "freight.track.notfound": "未找到该追踪号的货物。",
    "freight.track.summary": "概览",
    "freight.track.timeline": "记录",
    "freight.track.service": "服务类型",
    "freight.track.origin": "起点",
    "freight.track.dest": "目的地",
    "freight.track.eta": "预计送达",
    "freight.track.weight": "重量",
    "freight.track.volume": "体积",
    "freight.track.description": "货物",
    "freight.track.status": "当前状态",

    "status.created": "已登记",
    "status.picked_up": "义乌已取件",
    "status.in_transit_china": "中国境内运输中",
    "status.in_transit": "国际运输中",
    "status.arrived_port": "已抵达港口/机场",
    "status.customs_clearance": "清关中",
    "status.out_for_delivery": "派送中",
    "status.delivered": "已送达",
    "status.exception": "异常",
  },
  ar: {
    "nav.home": "الرئيسية",
    "nav.services": "الخدمات",
    "nav.sectors": "القطاعات",
    "nav.products": "الكتالوج",
    "nav.about": "حول",
    "nav.contact": "اتصل بنا",
    "nav.freight": "الشحن",
    "nav.transfer": "تحويل الأموال",
    "nav.study": "الدراسة في الصين",
    "nav.tracking": "تتبع الطرد",
    "nav.login": "تسجيل الدخول",
    "nav.register": "إنشاء حساب",
    "nav.logout": "تسجيل الخروج",
    "nav.dashboard": "مساحة العميل",
    "nav.admin": "المشرف",
    "home.kicker": "التوريد والبناء من نقطة واحدة · الصين منذ 2012",
    "home.title1": "مشروعك.",
    "home.title2": "خبرتنا.",
    "home.title3": "حل متكامل.",
    "home.subtitle": "NEGOSINO هو شريكك الوحيد في الصين للتوريد متعدد القطاعات، والبناء، والتجديد، وإدارة المشاريع تسليم مفتاح — من التحليل حتى التسليم النهائي.",
    "home.cta.quote": "طلب عرض سعر",
    "home.cta.services": "اكتشف خدماتنا",
    "home.stats.years": "سنوات في الصين (منذ 2012)",
    "home.stats.offices": "مكاتب: Yiwu و Guangzhou",
    "home.stats.sectors": "مجالات الخبرة",
    "home.services.kicker": "خدماتنا",
    "home.services.title1": "شريك واحد.",
    "home.services.title2": "كل المراحل.",
    "home.services.desc": "من التخطيط إلى التسليم، تنسّق NEGOSINO جميع مشاريعك بفضل شبكة قوية من المورّدين والمصنّعين والشركاء في الصين.",
    "home.sectors.kicker": "مجالات النشاط",
    "home.sectors.title": "نقوم بالتوريد لك، في كل أنحاء الصين.",
    "home.sectors.desc": "أربع عائلات رئيسية تغطيها فرقنا في Yiwu و Guangzhou، مع مراقبة جودة منهجية قبل الشحن.",
    "home.sectors.discover": "اكتشف",
    "sector.btp.t": "البناء والأشغال الثانوية والديكور",
    "sector.btp.d": "مواد، أشغال ثانوية، تجهيزات ومشاريع ديكور لمواقعك السكنية والتجارية.",
    "sector.btp.long": "من الهيكل إلى التشطيبات، تقوم NEGOSINO بتوريد جميع المواد والحلول التقنية لك. نرافق مواقع البناء السكنية والتجارية والفندقية بنهج ديكور متقن — من الأعمال الإنشائية حتى التجهيز النهائي.",
    "sector.btp.f1": "مواد البناء (بلاط، تجهيزات صحية، أحجار)",
    "sector.btp.f2": "نجارة، أبواب، نوافذ، زجاج وألمنيوم",
    "sector.btp.f3": "دهانات، كسوات وإضاءة معمارية",
    "sector.btp.f4": "تصميم داخلي وديكور حسب الطلب",
    "sector.industrial.t": "الآلات الصناعية",
    "sector.industrial.d": "معدات الإنتاج، خطوط كاملة، قطع غيار وآلات تشغيل المعادن لجميع القطاعات.",
    "sector.industrial.long": "تحدد NEGOSINO وتفاوض نيابةً عنك على الآلات الصناعية المناسبة لنشاطك — لدى أفضل المصنّعين الصينيين. نتولى المواصفات التقنية، تدقيق المصنع، اختبار الإنتاج والشحن الآمن.",
    "sector.industrial.f1": "خطوط إنتاج كاملة ومفتاح في اليد",
    "sector.industrial.f2": "ماكينات تشغيل المعادن (CNC، مكابس، قطع بالليزر)",
    "sector.industrial.f3": "معدات الصناعات الغذائية والتغليف",
    "sector.industrial.f4": "قطع غيار وخدمة ما بعد البيع",
    "sector.vehicles.t": "المركبات — شاحنات وسيارات",
    "sector.vehicles.d": "كامل التشكيلة: سيارات خاصة وشاحنات، جديدة ومستعملة. علامات صينية وواردات.",
    "sector.vehicles.long": "نرافقك في شراء المركبات — سيارات خاصة وشاحنات — في الصين. جديدة أو مستعملة، لدى الوكلاء أو مباشرة من المصنع. تشمل الخدمة الفحص الميكانيكي، أوراق التصدير، النقل والتخليص الجمركي.",
    "sector.vehicles.f1": "سيارات خاصة جديدة ومستعملة",
    "sector.vehicles.f2": "شاحنات: شاحنات قلاب، نصف مقطورات، قلابات، صهاريج",
    "sector.vehicles.f3": "مركبات نفعية ومعدات خاصة",
    "sector.vehicles.f4": "فحص ميكانيكي وأوراق التصدير",
    "sector.furniture.t": "الأثاث والإضاءة",
    "sector.furniture.d": "أثاث للمنزل والمكتب والفنادق والمطاعم. إضاءة بتصميم عصري، من الكتالوج أو تصنيع حسب الطلب.",
    "sector.furniture.long": "من الطاولة المصنوعة حسب الطلب إلى الثريا بتصميم عصري، نوفر مباشرةً من المصانع وورش العمل المتخصصة في Guangzhou وFoshan. فحص التشطيبات، تغليف مُعزّز للتصدير، والخدمة مشمولة.",
    "sector.furniture.f1": "أثاث المنزل والفنادق والمطاعم",
    "sector.furniture.f2": "أثاث المكاتب ومساحات العمل المفتوحة",
    "sector.furniture.f3": "الإضاءة: مصابيح معلّقة، مصابيح، أباليك",
    "sector.furniture.f4": "تصنيع حسب الطلب ونمذجة أولية",
    "sectors.kicker": "مجالات النشاط",
    "sectors.title": "أربع خبرات. نفس المعايير الصارمة.",
    "sectors.desc": "اكتشف بالتفصيل كل مجال من مجالات نشاطنا والإنجازات التي نفذناها مع عملائنا حول العالم.",
    "sectors.gallery": "إنجازاتنا",
    "sectors.gallery.desc": "لمحة عن مشاريع حديثة رافقتها فرقنا.",
    "sectors.offers": "ما الذي نغطيه",
    "sectors.back": "العودة إلى المجالات",
    "sectors.cta.title": "هل لديك مشروع في هذا المجال؟",
    "sectors.cta.desc": "صفه لنا، وسنعود إليك خلال 48h بتقدير أولي.",
    "home.about.kicker": "حول",
    "home.about.title1": "في الصين منذ 2012.",
    "home.about.title2": "مكتبان، جهة اتصال واحدة.",
    "home.about.desc": "توجد NEGOSINO في Yiwu وGuangzhou، وترافق عملاء من جميع أنحاء العالم في مشترياتهم ومشاريعهم في الصين. نهجنا One-Stop يبسّط كل شيء: جهة اتصال واحدة، من أول مكالمة حتى التسليم النهائي.",
    "home.about.stat1": "جهة اتصال واحدة",
    "home.about.stat2": "مدة الاستجابة",
    "home.about.more": "معرفة المزيد",
    "home.about.tracking": "تتبع فوري لكل مرحلة — التوريد، الإنتاج، مراقبة الجودة، الشحن، التسليم.",
    "home.logi.kicker": "نهج One-Stop",
    "home.logi.title": "من الفكرة إلى موقع العمل، بلا توتر.",
    "home.logi.desc": "ننسّق الموردين، الإنتاج، اللوجستيات وموقع العمل. أنت تحتفظ بالرؤية، ونحن ندير التنفيذ.",
    "home.logi.cta": "اتصل بنا",
    "home.cta.kicker": "جاهز للبدء؟",
    "home.cta.title1": "لنتحدث عن",
    "home.cta.title2": "مشروعك القادم",
    "home.cta.contact": "اتصل بنا",
    "home.cta.register": "إنشاء حساب عميل",
    "services.kicker": "خدماتنا",
    "services.title": "فريق واحد. جميع مراحل مشروعك.",
    "services.desc": "تتولى Negosino إدارة دورة مشروعك بالكامل — من البحث عن المورّدين إلى التسليم في الموقع — بفضل فرقها الموجودة في Yiwu و Guangzhou.",
    "services.cta.title": "هل لديك مشروع محدد في ذهنك؟",
    "services.cta.desc": "صفه، وسنعاود التواصل معك خلال 48 ساعة.",
    "services.cta.btn": "طلب عرض سعر",
    "svc2.construction.t": "🏗️ البناء وتطوير المشاريع",
    "svc2.construction.d": "بناء سكني وتجاري، مشاريع حسب الطلب، إدارة شاملة للأعمال، حلول مُكيّفة وفق متطلبات العميل.",
    "svc2.renovation.t": "🔨 الترميم والتحويل",
    "svc2.renovation.d": "ترميم شامل للمساحات، تحديث المباني، تجهيز داخلي وخارجي، تشطيبات مخصصة.",
    "svc2.onestop.t": "📋 إدارة مشروع One-Stop",
    "svc2.onestop.d": "تحليل وتحضير، حلول تقنية، تنسيق المورّدين والفرق، متابعة الإنتاج وورشة العمل، مراقبة الجودة، التسليم النهائي.",
    "svc2.sourcing.t": "🌏 توريد متعدد القطاعات",
    "svc2.sourcing.d": "البناء والأشغال العامة، آلات صناعية، السيارات، الشاحنات، الأثاث، العدد والأدوات — نحدد المورّدين المناسبين لاحتياجك ونتحقق منهم.",
    "svc2.quality.t": "🛡️ مراقبة الجودة",
    "svc2.quality.d": "عمليات تفتيش قبل الشحن، تقارير مفصلة، صور وفيديوهات تُشارك في الوقت الفعلي قبل كل عملية إرسال.",
    "svc2.logistics.t": "🚢 لوجستيات دولية",
    "svc2.logistics.d": "بحري FCL/LCL، جوي، سككي الصين-أوروبا. التخليص الجمركي والتسليم النهائي من الباب إلى الباب.",
    "why.kicker": "لماذا Negosino؟",
    "why.title": "خبرة مبنية على أرض الواقع.",
    "why.1.t": "12+ سنة في الصين",
    "why.1.d": "خبرة طُوّرت منذ 2012 بفضل العديد من المشاريع التي تم إنجازها بنجاح.",
    "why.2.t": "جهة تواصل واحدة",
    "why.2.d": "إدارة مبسطة، وفريق مسؤول عن جميع مراحل المشروع.",
    "why.3.t": "وجود مباشر في الصين",
    "why.3.d": "مكاتبنا في Yiwu و Guangzhou تدير الشركاء والمورّدين والإنتاج بكفاءة.",
    "why.4.t": "رؤية دولية",
    "why.4.d": "تواصل واضح ومتابعة مخصصة لعملائنا حول العالم.",
    "products.kicker": "الكتالوج",
    "products.title1": "دفعات مختارة.",
    "products.title2": "جاهزة للشحن.",
    "products.desc": "اكتشف الدفعات المتاحة حالياً. لأي طلب مخصص، تواصل معنا.",
    "products.empty": "لا توجد منتجات متاحة حالياً.",
    "products.from": "ابتداءً من",
    "products.buy": "شراء",
    "products.err": "حدث خطأ أثناء إنشاء الدفع.",
    "products.rate": "سعر إرشادي",
    "about.kicker": "حول",
    "about.title1": "مشروعك.",
    "about.title2": "خبرتنا.",
    "about.title3": "حل متكامل.",
    "about.p1": "NEGOSINO هو شريكك الواحد لجميع مشاريع البناء والتجديد والتهيئة وعمليات السورسينغ في الصين. مع أكثر من 12 سنة من الخبرة منذ 2012، نرافق عملاءنا عبر نهج One-Stop، مع تولّي كل مرحلة من المشروع، من التخطيط حتى التنفيذ النهائي.",
    "about.p2": "متمركزة في الصين مع مكتبين استراتيجيين في Yiwu و Guangzhou، تستفيد NEGOSINO من شبكة قوية من المورّدين والمصنّعين والشركاء المهنيين لتقديم حلول موثوقة وتنافسية ومكيّفة مع احتياجات كل عميل.",
    "about.p3": "في NEGOSINO، نحوّل أفكارك إلى مشاريع مُنجزة عبر نهج قائم على الجودة والموثوقية والتحكم في التكاليف. فريقنا متعدد اللغات (الماندرين، الفرنسية، الإنجليزية) يتقن الرموز الثقافية والتقنية واللوجستية الضرورية لنجاح عملياتك في الصين.",
    "about.commitments": "التزامنا",
    "about.c1.b": "الجودة والموثوقية.",
    "about.c1.t": "فحص منهجي قبل كل شحنة، دون أي عمولات مخفية.",
    "about.c2.b": "التحكم في التكاليف.",
    "about.c2.t": "تفاوض حازم وشفافية كاملة بشأن كل بند من بنود الإنفاق.",
    "about.c3.b": "الرد خلال 48 ساعة.",
    "about.c3.t": "دائمًا، حتى في عطلة نهاية الأسبوع، وباللغة التي تختارها.",
    "contact.kicker": "تواصل",
    "contact.title": "لنتحدث عن مشروعك.",
    "contact.desc": "صف لنا احتياجك — المنتج، الكمية، السوق المستهدف أو مشروع البناء. سيعود إليك فريقنا خلال 48 ساعة مع تقدير أولي.",
    "contact.office.yiwu": "مكتب Yiwu",
    "contact.office.yiwu.addr": "Office 1517, China-Africa Building, No. J9 Chengda Avenue, Futian, Yiwu, Zhejiang, Chine",
    "contact.office.gz": "مكتب Guangzhou",
    "contact.office.gz.addr": "UnitÃ© C038, 5e-6e Ã©tage, No. 80-86 Xiwan Road, District de Liwan, Guangzhou, Guangdong, Chine",
    "contact.email": "البريد الإلكتروني",
    "contact.wa1": "WhatsApp — الخط 1",
    "contact.wa2": "WhatsApp — الخط 2",
    "contact.wa3": "WhatsApp — الخط 3",
    "contact.wa.hint": "انقر للدردشة",
    "contact.name": "الاسم الكامل",
    "contact.emailFld": "البريد الإلكتروني",
    "contact.subject": "الموضوع",
    "contact.message": "رسالتك — المنتج، الكمية، السوق المستهدف، المشروع…",
    "contact.send": "إرسال",
    "contact.sending": "جارٍ الإرسال…",
    "contact.success": "تم إرسال الرسالة. سنعود إليك قريبًا جدًا.",
    "auth.login.kicker": "مساحة العميل",
    "auth.login.title": "مرحبًا بعودتك.",
    "auth.login.desc": "سجّل الدخول إلى حسابك في NEGOSINO.",
    "auth.login.submit": "تسجيل الدخول",
    "auth.login.loading": "جارٍ تسجيل الدخول…",
    "auth.login.noAccount": "ليس لديك حساب بعد؟",
    "auth.login.createAcc": "إنشاء حساب",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.register.kicker": "حساب جديد",
    "auth.register.title": "انضم إلى NEGOSINO.",
    "auth.register.desc": "تتبّع طلباتك وعروض الأسعار ورسائلك — في مكان واحد.",
    "auth.register.submit": "إنشاء حسابي",
    "auth.register.loading": "جارٍ الإنشاء…",
    "auth.register.have": "مسجّل بالفعل؟",
    "auth.register.login": "تسجيل الدخول",
    "auth.name": "الاسم الكامل",
    "auth.passwordMin": "كلمة المرور (حد أدنى 6)",
    "dash.kicker": "مساحة العميل",
    "dash.welcome": "مرحبًا",
    "dash.desc": "من خلال هذه المساحة، اعثر على طلبات عروض الأسعار ومشاريعك وجميع محادثاتك مع فريقنا.",
    "dash.card1.t": "طلب جديد",
    "dash.card1.d": "صف مشروعك وتلقَّ عرض سعر خلال 48 ساعة.",
    "dash.card2.t": "الكتالوج",
    "dash.card2.d": "اكتشف الدفعات المتاحة حاليًا.",
    "dash.card3.t": "محادثة",
    "dash.card3.d": "استخدم الدردشة أسفل اليمين للتحدث مع الذكاء الاصطناعي أو مع فريقنا.",
    "dash.account": "حسابي",
    "dash.role": "الدور",
    "footer.about.kicker": "NEGOSINO",
    "footer.about.desc1": "حلول شاملة للبناء والتوريد — في الصين منذ 2012.",
    "footer.about.desc2": "مكتبان في Yiwu و Guangzhou. جهة اتصال واحدة لتوريدك وبنائك وإدارة مشروعك.",
    "footer.nav": "التنقّل",
    "footer.contact": "اتصل بنا",
    "footer.rights": "جميع الحقوق محفوظة.",
    "footer.tagline": "مشروعك. خبرتنا. حل متكامل.",
    "footer.follow": "تابعنا",
    "featured.kicker": "متجر إلكتروني",
    "featured.title": "منتجات متوفرة في المخزون، جاهزة للطلب.",
    "featured.desc": "مجموعة من المنتجات المتوفرة في مستودعاتنا في Yiwu و Guangzhou. اطلب بنقرة واحدة.",
    "featured.see_all": "عرض كامل الكتالوج",
    "stock.in": "متوفر",
    "stock.low": "مخزون محدود",
    "stock.out": "نفاد المخزون",
    "stock.senegal": "مخزون السنغال",
    "filter.all": "جميع الفئات",
    "banner.promo": "🎁 -10% على حفاضات الأطفال والكبار هذا الشهر — الحد الأدنى للطلب كرتون واحد",
    "banner.cta": "الاستفادة من العرض",
    "tiktok.kicker": "على TikTok",
    "tiktok.title": "اكتشف كواليسنا ومشاريعنا في الصين.",
    "tiktok.desc": "تابع يومياتنا في Yiwu و Guangzhou: زيارات المصانع، فحوصات الجودة، المشاريع المنجزة، وأفضل اختياراتنا.",
    "tiktok.video": "فيديو",
    "chat.title.ai": "Sino · مساعد ذكاء اصطناعي",
    "chat.title.support": "دعم بشري",
    "chat.header": "NEGOSINO · محادثة",
    "chat.tab.ai": "الذكاء الاصطناعي",
    "chat.tab.support": "بشري",
    "chat.placeholder.ai": "اطرح سؤالك…",
    "chat.placeholder.support": "رسالتك…",
    "chat.support.empty": "أرسل رسالتك — سيرد عليك فريقنا بمجرد أن يتوفر.",
    "chat.hello": "مرحبًا 👋 أنا Sino، مساعد NEGOSINO. كيف يمكنني مساعدتك في مشروعك في الصين؟",
    "chat.error": "عذرًا، الذكاء الاصطناعي غير متاح مؤقتًا.",
    "lang.label": "اللغة",
    "pay.success.title": "تم تأكيد الدفع!",
    "pay.success.desc": "تم إرسال بريد إلكتروني للتأكيد. شكرًا لثقتك.",
    "pay.expired.title": "انتهت الجلسة",
    "pay.expired.desc": "يرجى إعادة محاولة الدفع.",
    "pay.checking": "جارٍ التحقق من الدفع…",
    "pay.back": "العودة إلى الكتالوج",
    "pay.cancel.title": "تم إلغاء الدفع",
    "pay.cancel.desc": "لم يتم تنفيذ أي معاملة. يمكنك المحاولة مرة أخرى في أي وقت.",
    "freight.kicker": "الشحن الصين → السنغال",
    "freight.title": "بضائعك تُشحن، تُتابَع، وتُسلَّم.",
    "freight.desc": "من مستودعنا في Yiwu، نقوم بتجميع وشحن طرودك إلى Dakar والسنغال — شحن عادي أو سريع. تتبع فوري من البداية إلى النهاية.",
    "freight.cta.quote": "طلب عرض سعر",
    "freight.cta.track": "تتبع طرد",
    "freight.services.title": "ثلاث باقات مناسبة لاحتياجك",
    "freight.express.badge": "الأسرع",
    "freight.express.title": "شحن سريع · جوي",
    "freight.express.time": "3 إلى 5 أيام",
    "freight.express.price": "12 000 FCFA / kg",
    "freight.express.price.hint": "≈ 18 € / kg",
    "freight.express.desc": "مثالي للحالات العاجلة والطرود ذات القيمة العالية. انطلاقًا من Yiwu إلى Dakar مع تتبع دقيق وإشعارات.",
    "freight.express.f1": "استلام سريع في Yiwu",
    "freight.express.f2": "تتبع دقيق وإشعارات",
    "freight.express.f3": "مثالي للأحجام الصغيرة العاجلة",
    "freight.normal.badge": "قياسي",
    "freight.normal.title": "شحن عادي · جوي",
    "freight.normal.time": "10 إلى 15 يومًا",
    "freight.normal.price": "8 000 FCFA / كغ",
    "freight.normal.price.hint": "≈ 12 € / كغ",
    "freight.normal.desc": "أفضل توازن بين المدة والسعر لشحناتك المنتظمة. الانطلاق من Yiwu إلى Dakar.",
    "freight.normal.f1": "توازن جيد بين المدة والتعرفة",
    "freight.normal.f2": "إمكانية التجميع مع عملاء آخرين",
    "freight.normal.f3": "التسليم في Dakar مشمول",
    "freight.maritime.badge": "اقتصادي",
    "freight.maritime.title": "شحن بحري · حاوية",
    "freight.maritime.time": "40 إلى 55 يومًا",
    "freight.maritime.price": "170 000 FCFA / م³",
    "freight.maritime.price.hint": "≈ 260 € / م³ · سعر إرشادي",
    "freight.maritime.desc": "الحل الأكثر اقتصادية للأحجام الكبيرة. الانطلاق من Yiwu و Guangzhou إلى Dakar. قد يختلف سعر CBM حسب الموسم.",
    "freight.maritime.f1": "تجميع حاويات 20/40 قدمًا",
    "freight.maritime.f2": "انطلاق من Yiwu و Guangzhou",
    "freight.maritime.f3": "الجمارك والتسليم في Dakar مشمولان",
    "freight.included": "ما الذي تتضمنه كل باقة",
    "freight.pickup.kicker": "استلام في Dakar",
    "freight.pickup.title": "استلم طرودك السريعة في Dakar Mariste",
    "freight.pickup.desc": "بعد وصولها إلى Dakar، يمكن استلام طرودك السريعة مباشرةً من نقطة الاستلام لدينا في Dakar Mariste، بين بنك BICIS وبنك SGBS.",
    "freight.pickup.addr.label": "العنوان",
    "freight.pickup.addr": "Dakar Mariste — بين بنك BICIS وبنك SGBS",
    "freight.pickup.agent.label": "وكيل Dakar",
    "freight.pickup.agent.hint": "اتصل بوكيلنا لتنظيم الاستلام",
    "freight.pickup.map": "عرض على الخريطة",
    "freight.pickup.directions": "المسار على Google Maps",
    "freight.pickup.call": "اتصال",
    "freight.pickup.whatsapp": "WhatsApp",
    "freight.i1": "استلام من Yiwu",
    "freight.i2": "فحص وتغليف للتصدير",
    "freight.i3": "الوثائق والتخليص الجمركي",
    "freight.i4": "تتبع لحظي عبر رقم NGS-XXXXXXXX",
    "freight.i5": "التسليم إلى Dakar (أو أي مدينة أخرى عند الطلب)",
    "freight.track.title": "تتبع الطرود",
    "freight.track.desc": "أدخل رقم التتبع الخاص بك (بالصيغة NGS-XXXXXXXX) لعرض حالة شحنتك في الوقت الفعلي.",
    "freight.track.placeholder": "NGS-XXXXXXXX",
    "freight.track.btn": "تتبع",
    "freight.track.notfound": "لم يتم العثور على أي شحنة لهذا الرقم.",
    "freight.track.summary": "ملخص",
    "freight.track.timeline": "السجل",
    "freight.track.service": "نوع الخدمة",
    "freight.track.origin": "المنشأ",
    "freight.track.dest": "الوجهة",
    "freight.track.eta": "موعد التسليم المتوقع",
    "freight.track.weight": "الوزن",
    "freight.track.volume": "الحجم",
    "freight.track.description": "المحتوى",
    "freight.track.status": "الحالة الحالية",
    "status.created": "تم التسجيل",
    "status.picked_up": "تم الاستلام من Yiwu",
    "status.in_transit_china": "قيد النقل داخل الصين",
    "status.in_transit": "قيد النقل الدولي",
    "status.arrived_port": "وصل إلى الميناء/المطار",
    "status.customs_clearance": "التخليص الجمركي",
    "status.out_for_delivery": "قيد التسليم",
    "status.delivered": "تم التسليم",
    "status.exception": "حادث",
  },
  es: {
    "nav.home": "Inicio",
    "nav.services": "Servicios",
    "nav.sectors": "Sectores",
    "nav.products": "Catálogo",
    "nav.about": "Acerca de",
    "nav.contact": "Contacto",
    "nav.freight": "Flete",
    "nav.transfer": "Transferencia de dinero",
    "nav.study": "Estudiar en China",
    "nav.tracking": "Seguimiento de paquete",
    "nav.login": "Iniciar sesión",
    "nav.register": "Crear una cuenta",
    "nav.logout": "Cerrar sesión",
    "nav.dashboard": "Área de cliente",
    "nav.admin": "Admin",
    "home.kicker": "One-Stop Sourcing & Construction · China desde 2012",
    "home.title1": "Tu proyecto.",
    "home.title2": "Nuestra experiencia.",
    "home.title3": "Una solución completa.",
    "home.subtitle": "NEGOSINO es tu socio único en China para el sourcing multisectorial, la construcción, la renovación y la gestión de proyectos llave en mano — desde el análisis hasta la entrega final.",
    "home.cta.quote": "Solicitar una cotización",
    "home.cta.services": "Descubrir nuestros servicios",
    "home.stats.years": "años en China (desde 2012)",
    "home.stats.offices": "oficinas: Yiwu & Guangzhou",
    "home.stats.sectors": "áreas de experiencia",
    "home.services.kicker": "Nuestros servicios",
    "home.services.title1": "Un socio.",
    "home.services.title2": "Todas las etapas.",
    "home.services.desc": "De la planificación a la entrega, NEGOSINO coordina todos tus proyectos gracias a una sólida red de proveedores, fabricantes y socios en China.",
    "home.sectors.kicker": "Áreas de actividad",
    "home.sectors.title": "Hacemos sourcing para ti, en toda China.",
    "home.sectors.desc": "Cuatro grandes familias cubiertas por nuestros equipos de Yiwu y Guangzhou, con control de calidad sistemático antes del envío.",
    "home.sectors.discover": "Descubrir",
    "sector.btp.t": "Construcción, acabados & decoración",
    "sector.btp.d": "Materiales, acabados, acondicionamientos y proyectos de decoración para tus obras residenciales y comerciales.",
    "sector.btp.long": "De la estructura a los acabados, NEGOSINO hace sourcing para ti de todos los materiales y soluciones técnicas. Acompañamos obras residenciales, comerciales y hoteleras con un enfoque de decoración cuidado — desde la obra gruesa hasta el acondicionamiento final.",
    "sector.btp.f1": "Materiales de construcción (azulejos, sanitario, piedras)",
    "sector.btp.f2": "Carpintería, puertas, ventanas, vidrio & aluminio",
    "sector.btp.f3": "Pinturas, revestimientos e iluminación arquitectónica",
    "sector.btp.f4": "Acondicionamiento interior y decoración a medida",
    "sector.industrial.t": "Máquinas industriales",
    "sector.industrial.d": "Equipos de producción, líneas completas, repuestos y máquinas-herramienta para todos los sectores.",
    "sector.industrial.long": "NEGOSINO identifica y negocia por usted las máquinas industriales adecuadas para su actividad — con los mejores fabricantes chinos. Nos encargamos de la especificación técnica, la auditoría del fabricante, la prueba de producción y el envío seguro.",
    "sector.industrial.f1": "Líneas de producción completas y llave en mano",
    "sector.industrial.f2": "Máquinas-herramienta (CNC, prensas, corte láser)",
    "sector.industrial.f3": "Equipos agroalimentarios y empaque",
    "sector.industrial.f4": "Repuestos y servicio posventa",
    "sector.vehicles.t": "Vehículos — camiones y autos",
    "sector.vehicles.d": "Toda la gama: autos particulares y camiones, nuevos y usados. Marcas chinas e importaciones.",
    "sector.vehicles.long": "Le acompañamos en la compra de vehículos — autos particulares y camiones — en China. Nuevos o usados, con concesionarios o directo de fábrica. Incluye verificación mecánica, documentos de exportación, transporte y despacho aduanero.",
    "sector.vehicles.f1": "Autos particulares nuevos y usados",
    "sector.vehicles.f2": "Camiones: rígidos, semirremolques, volquetes, cisternas",
    "sector.vehicles.f3": "Vehículos utilitarios y maquinaria especial",
    "sector.vehicles.f4": "Inspección mecánica y documentos de exportación",
    "sector.furniture.t": "Mobiliario e iluminación",
    "sector.furniture.d": "Mobiliario para hogar, oficina, hotelería y restauración. Iluminación de diseño, de catálogo o fabricación a medida.",
    "sector.furniture.long": "De la mesa a medida al candelabro de diseño, hacemos sourcing directo con fabricantes y talleres especializados de Guangzhou y Foshan. Control de acabados, embalaje reforzado para exportación, servicio incluido.",
    "sector.furniture.f1": "Mobiliario para hogar, hotel y restauración",
    "sector.furniture.f2": "Mobiliario de oficina y open space",
    "sector.furniture.f3": "Iluminación: colgantes, lámparas, apliques",
    "sector.furniture.f4": "Fabricación a medida y prototipado",
    "sectors.kicker": "Áreas de actividad",
    "sectors.title": "Cuatro especialidades. Una misma exigencia.",
    "sectors.desc": "Descubra en detalle cada una de nuestras áreas de actividad y los proyectos realizados con nuestros clientes en todo el mundo.",
    "sectors.gallery": "Nuestros proyectos",
    "sectors.gallery.desc": "Vista previa de proyectos recientes acompañados por nuestros equipos.",
    "sectors.offers": "Lo que cubrimos",
    "sectors.back": "Volver a las áreas",
    "sectors.cta.title": "¿Un proyecto en esta área?",
    "sectors.cta.desc": "Descríbalo y le responderemos en 48 h con una primera estimación.",
    "home.about.kicker": "Acerca de",
    "home.about.title1": "En China desde 2012.",
    "home.about.title2": "Dos oficinas, un solo interlocutor.",
    "home.about.desc": "Con presencia en Yiwu y Guangzhou, NEGOSINO acompaña a clientes de todo el mundo en sus compras y proyectos en China. Nuestro enfoque One-Stop lo simplifica todo: un solo contacto, desde la primera llamada hasta la entrega final.",
    "home.about.stat1": "Un solo interlocutor",
    "home.about.stat2": "Tiempo de respuesta",
    "home.about.more": "Saber más",
    "home.about.tracking": "Seguimiento en tiempo real de cada etapa — sourcing, producción, control de calidad, envío, entrega.",
    "home.logi.kicker": "Enfoque One-Stop",
    "home.logi.title": "De la idea a la obra, sin estrés.",
    "home.logi.desc": "Coordinamos proveedores, producción, logística y obra. Usted mantiene la visión, nosotros gestionamos la ejecución.",
    "home.logi.cta": "Contáctenos",
    "home.cta.kicker": "¿Listo para empezar?",
    "home.cta.title1": "Hablemos de su próximo",
    "home.cta.title2": "proyecto",
    "home.cta.contact": "Contáctenos",
    "home.cta.register": "Crear una cuenta de cliente",
    "services.kicker": "Nuestros servicios",
    "services.title": "Un equipo. Todas las etapas de su proyecto.",
    "services.desc": "NEGOSINO gestiona todo el ciclo de su proyecto — desde la búsqueda de proveedores hasta la entrega en obra — gracias a sus equipos con base en Yiwu y Guangzhou.",
    "services.cta.title": "¿Tiene un proyecto específico en mente?",
    "services.cta.desc": "Descríbalo, le responderemos en 48 h.",
    "services.cta.btn": "Solicitar una cotización",
    "svc2.construction.t": "🏗️ Construcción y desarrollo de proyectos",
    "svc2.construction.d": "Construcción residencial y comercial, proyectos a medida, gestión integral de obra, soluciones adaptadas a las exigencias del cliente.",
    "svc2.renovation.t": "🔨 Renovación y transformación",
    "svc2.renovation.d": "Renovación integral de espacios, modernización de edificios, acondicionamiento interior y exterior, acabados personalizados.",
    "svc2.onestop.t": "📋 Gestión de proyecto One-Stop",
    "svc2.onestop.d": "Análisis y preparación, soluciones técnicas, coordinación de proveedores y equipos, seguimiento de producción y obra, control de calidad, entrega final.",
    "svc2.sourcing.t": "🌏 Sourcing multisectorial",
    "svc2.sourcing.d": "BTP, maquinaria industrial, automotriz, camiones, mobiliario, ferretería — identificamos y verificamos los proveedores adecuados para su necesidad.",
    "svc2.quality.t": "🛡️ Control de calidad",
    "svc2.quality.d": "Inspecciones antes de la carga, informes detallados, fotos y videos compartidos en tiempo real antes de cada envío.",
    "svc2.logistics.t": "🚢 Logística internacional",
    "svc2.logistics.d": "Marítimo FCL/LCL, aéreo, ferroviario China-Europa. Despacho aduanal y entrega final puerta a puerta.",
    "why.kicker": "¿Por qué NEGOSINO?",
    "why.title": "Un saber hacer construido en el terreno.",
    "why.1.t": "12+ años en China",
    "why.1.d": "Experiencia desarrollada desde 2012 gracias a numerosos proyectos realizados con éxito.",
    "why.2.t": "Un solo interlocutor",
    "why.2.d": "Gestión simplificada, un equipo responsable de todas las etapas del proyecto.",
    "why.3.t": "Presencia directa en China",
    "why.3.d": "Nuestras oficinas en Yiwu y Guangzhou gestionan de forma eficiente socios, proveedores y producción.",
    "why.4.t": "Visión internacional",
    "why.4.d": "Comunicación clara y seguimiento personalizado para nuestros clientes en todo el mundo.",
    "products.kicker": "Catálogo",
    "products.title1": "Lotes seleccionados.",
    "products.title2": "Listos para enviar.",
    "products.desc": "Descubra los lotes disponibles actualmente. Para cualquier solicitud personalizada, contáctenos.",
    "products.empty": "No hay productos disponibles por el momento.",
    "products.from": "Desde",
    "products.buy": "Comprar",
    "products.err": "Error al crear el pago.",
    "products.rate": "tasa indicativa",
    "about.kicker": "Acerca de",
    "about.title1": "Su proyecto.",
    "about.title2": "Nuestra experiencia.",
    "about.title3": "Una solución completa.",
    "about.p1": "NEGOSINO es su socio único para todos sus proyectos de construcción, renovación, acondicionamiento y sourcing en China. Con más de 12 años de experiencia desde 2012, acompañamos a nuestros clientes con un enfoque One-Stop, haciéndonos cargo de cada etapa del proyecto, desde la planificación hasta la realización final.",
    "about.p2": "Con sede en China y dos oficinas estratégicas en Yiwu y Guangzhou, NEGOSINO cuenta con una sólida red de proveedores, fabricantes y socios profesionales que permite ofrecer soluciones confiables, competitivas y adaptadas a las necesidades de cada cliente.",
    "about.p3": "En NEGOSINO, transformamos sus ideas en proyectos realizados con un enfoque basado en la calidad, la confiabilidad y el control de costos. Nuestro equipo multilingüe (mandarín, francés, inglés) domina los códigos culturales, técnicos y logísticos indispensables para el éxito de sus operaciones en China.",
    "about.commitments": "Nuestro compromiso",
    "about.c1.b": "Calidad y confiabilidad.",
    "about.c1.t": "Control sistemático antes de cada envío, sin comisiones ocultas.",
    "about.c2.b": "Control de costos.",
    "about.c2.t": "Negociación firme y total transparencia en cada rubro de gasto.",
    "about.c3.b": "Respuesta en 48 horas.",
    "about.c3.t": "Siempre, incluso los fines de semana, en el idioma de su elección.",
    "contact.kicker": "Contacto",
    "contact.title": "Hablemos de su proyecto.",
    "contact.desc": "Descríbanos su necesidad — producto, volumen, mercado objetivo o proyecto de construcción. Nuestro equipo se pondrá en contacto con usted en 48 horas con una primera estimación.",
    "contact.office.yiwu": "Oficina Yiwu",
    "contact.office.yiwu.addr": "Oficina 1517, China-Africa Building, No. J9 Chengda Avenue, Futian, Yiwu, Zhejiang, China",
    "contact.office.gz": "Oficina Guangzhou",
    "contact.office.gz.addr": "Unidad C038, 5º-6º piso, No. 80-86 Xiwan Road, Distrito de Liwan, Guangzhou, Guangdong, China",
    "contact.email": "Email",
    "contact.wa1": "WhatsApp — Línea 1",
    "contact.wa2": "WhatsApp — Línea 2",
    "contact.wa3": "WhatsApp — Línea 3",
    "contact.wa.hint": "haga clic para chatear",
    "contact.name": "Nombre completo",
    "contact.emailFld": "Email",
    "contact.subject": "Asunto",
    "contact.message": "Su mensaje — producto, volumen, mercado objetivo, proyecto…",
    "contact.send": "Enviar",
    "contact.sending": "Enviando…",
    "contact.success": "Mensaje enviado. Nos pondremos en contacto con usted muy pronto.",
    "auth.login.kicker": "Área de clientes",
    "auth.login.title": "Bienvenido de nuevo.",
    "auth.login.desc": "Inicie sesión en su cuenta NEGOSINO.",
    "auth.login.submit": "Iniciar sesión",
    "auth.login.loading": "Iniciando sesión…",
    "auth.login.noAccount": "¿Aún no tienes cuenta?",
    "auth.login.createAcc": "Crear una cuenta",
    "auth.email": "Email",
    "auth.password": "Contraseña",
    "auth.register.kicker": "Nueva cuenta",
    "auth.register.title": "Únete a NEGOSINO.",
    "auth.register.desc": "Seguimiento de tus solicitudes, cotizaciones y mensajes — en un solo lugar.",
    "auth.register.submit": "Crear mi cuenta",
    "auth.register.loading": "Creando…",
    "auth.register.have": "¿Ya estás registrado?",
    "auth.register.login": "Iniciar sesión",
    "auth.name": "Nombre completo",
    "auth.passwordMin": "Contraseña (mín 6)",
    "dash.kicker": "Área de clientes",
    "dash.welcome": "Bienvenido",
    "dash.desc": "Desde este espacio, encuentra tus solicitudes de cotización, tus proyectos y todas tus conversaciones con nuestro equipo.",
    "dash.card1.t": "Nueva solicitud",
    "dash.card1.d": "Describe tu proyecto y recibe una cotización en 48 h.",
    "dash.card2.t": "Catálogo",
    "dash.card2.d": "Descubre los lotes disponibles actualmente.",
    "dash.card3.t": "Chat",
    "dash.card3.d": "Usa el chat abajo a la derecha para hablar con la IA o con nuestro equipo.",
    "dash.account": "Mi cuenta",
    "dash.role": "Rol",
    "footer.about.kicker": "NEGOSINO",
    "footer.about.desc1": "One-Stop Construction & Sourcing Solutions — en China desde 2012.",
    "footer.about.desc2": "Dos oficinas en Yiwu y Guangzhou. Un solo interlocutor para tu sourcing, tu construcción y tu gestión de proyectos.",
    "footer.nav": "Navegación",
    "footer.contact": "Contacto",
    "footer.rights": "Todos los derechos reservados.",
    "footer.tagline": "Tu proyecto. Nuestra experiencia. Una solución completa.",
    "footer.follow": "Síguenos",
    "featured.kicker": "Tienda en línea",
    "featured.title": "Productos en stock, listos para pedir.",
    "featured.desc": "Una selección de productos disponibles en nuestros almacenes de Yiwu y Guangzhou. Pide con un clic.",
    "featured.see_all": "Ver todo el catálogo",
    "stock.in": "En stock",
    "stock.low": "Stock limitado",
    "stock.out": "Agotado",
    "stock.senegal": "Stock Senegal",
    "filter.all": "Todas las categorías",
    "banner.promo": "🎁 -10% en pañales bebé y adultos este mes — pedido mínimo 1 cartón",
    "banner.cta": "Aprovechar la oferta",
    "tiktok.kicker": "En TikTok",
    "tiktok.title": "Descubre nuestro detrás de escena y nuestros proyectos en China.",
    "tiktok.desc": "Sigue nuestro día a día en Yiwu y Guangzhou: visitas a fábricas, controles de calidad, proyectos realizados, favoritos.",
    "tiktok.video": "Video",
    "chat.title.ai": "Sino · Asistente IA",
    "chat.title.support": "Soporte humano",
    "chat.header": "NEGOSINO · Chat",
    "chat.tab.ai": "IA",
    "chat.tab.support": "Humano",
    "chat.placeholder.ai": "Haz tu pregunta…",
    "chat.placeholder.support": "Tu mensaje…",
    "chat.support.empty": "Envía tu mensaje — nuestro equipo te responde en cuanto esté disponible.",
    "chat.hello": "Hola 👋 soy Sino, el asistente de NEGOSINO. ¿Cómo puedo ayudarte con tu proyecto en China?",
    "chat.error": "Lo sentimos, la IA no está disponible temporalmente.",
    "lang.label": "Idioma",
    "pay.success.title": "¡Pago confirmado!",
    "pay.success.desc": "Se te envió un email de confirmación. Gracias por tu confianza.",
    "pay.expired.title": "Sesión expirada",
    "pay.expired.desc": "Por favor, vuelve a intentar el pago.",
    "pay.checking": "Verificando el pago…",
    "pay.back": "Volver al catálogo",
    "pay.cancel.title": "Pago cancelado",
    "pay.cancel.desc": "No se realizó ninguna transacción. Puedes intentarlo de nuevo en cualquier momento.",
    "freight.kicker": "Flete China → Senegal",
    "freight.title": "Tus mercancías transportadas, rastreadas y entregadas.",
    "freight.desc": "Desde nuestro almacén en Yiwu, consolidamos y enviamos tus paquetes a Dakar y Senegal — en flete normal o express. Seguimiento en tiempo real de principio a fin.",
    "freight.cta.quote": "Solicitar una cotización",
    "freight.cta.track": "Rastrear un paquete",
    "freight.services.title": "Tres opciones adaptadas a tu necesidad",
    "freight.express.badge": "El más rápido",
    "freight.express.title": "Flete express · Aéreo",
    "freight.express.time": "3 a 5 días",
    "freight.express.price": "12 000 FCFA / kg",
    "freight.express.price.hint": "≈ 18 € / kg",
    "freight.express.desc": "Ideal para urgencias y paquetes de alto valor. Salida desde Yiwu hacia Dakar con seguimiento cercano y notificaciones.",
    "freight.express.f1": "Recogida rápida en Yiwu",
    "freight.express.f2": "Seguimiento cercano y notificaciones",
    "freight.express.f3": "Ideal para pequeños volúmenes urgentes",
    "freight.normal.badge": "Estándar",
    "freight.normal.title": "Flete normal · Aéreo",
    "freight.normal.time": "10 a 15 días",
    "freight.normal.price": "8 000 FCFA / kg",
    "freight.normal.price.hint": "≈ 12 € / kg",
    "freight.normal.desc": "La mejor relación tiempo/precio para sus envíos regulares. Salida de Yiwu hacia Dakar.",
    "freight.normal.f1": "Buen equilibrio tiempo / tarifa",
    "freight.normal.f2": "Posible consolidación con otros clientes",
    "freight.normal.f3": "Entrega en Dakar incluida",
    "freight.maritime.badge": "Económico",
    "freight.maritime.title": "Flete marítimo · Contenedor",
    "freight.maritime.time": "40 a 55 días",
    "freight.maritime.price": "170 000 FCFA / m³",
    "freight.maritime.price.hint": "Productos normales · ≈ €260 / m³",
    "freight.maritime.desc": "La solución más económica para grandes volúmenes. Salida desde Yiwu y Guangzhou hacia Dakar. El precio por CBM puede variar según la temporada.",
    "freight.maritime.f1": "Consolidación 20/40 pies",
    "freight.maritime.f2": "Salida Yiwu & Guangzhou",
    "freight.maritime.f3": "Aduanas y entrega en Dakar incluidas",
    "freight.included": "Lo que está incluido en cada plan",
    "freight.pickup.kicker": "Retiro en Dakar",
    "freight.pickup.title": "Recoja sus paquetes express en Dakar Mariste",
    "freight.pickup.desc": "Una vez llegados a Dakar, sus paquetes express pueden recogerse directamente en nuestro punto de retiro en Dakar Mariste, entre el banco BICIS y el banco SGBS.",
    "freight.pickup.addr.label": "Dirección",
    "freight.pickup.addr": "Dakar Mariste — entre el banco BICIS y el banco SGBS",
    "freight.pickup.agent.label": "Agente Dakar",
    "freight.pickup.agent.hint": "Llame a nuestro agente para organizar el retiro",
    "freight.pickup.map": "Ver en el mapa",
    "freight.pickup.directions": "Ruta en Google Maps",
    "freight.pickup.call": "Llamar",
    "freight.pickup.whatsapp": "WhatsApp",
    "freight.i1": "Recogida en Yiwu",
    "freight.i2": "Control y embalaje de exportación",
    "freight.i3": "Documentación y despacho aduanero",
    "freight.i4": "Seguimiento en tiempo real con número NGS-XXXXXXXX",
    "freight.i5": "Entrega en Dakar (o cualquier otra ciudad bajo solicitud)",
    "freight.track.title": "Seguimiento de paquetes",
    "freight.track.desc": "Ingrese su número de seguimiento (formato NGS-XXXXXXXX) para ver el estado de su envío en tiempo real.",
    "freight.track.placeholder": "NGS-XXXXXXXX",
    "freight.track.btn": "Rastrear",
    "freight.track.notfound": "No se encontró ningún envío para este número.",
    "freight.track.summary": "Resumen",
    "freight.track.timeline": "Historial",
    "freight.track.service": "Tipo de servicio",
    "freight.track.origin": "Origen",
    "freight.track.dest": "Destino",
    "freight.track.eta": "Entrega estimada",
    "freight.track.weight": "Peso",
    "freight.track.volume": "Volumen",
    "freight.track.description": "Contenido",
    "freight.track.status": "Estado actual",
    "status.created": "Registrado",
    "status.picked_up": "Recogido en Yiwu",
    "status.in_transit_china": "En tránsito en China",
    "status.in_transit": "En tránsito internacional",
    "status.arrived_port": "Llegó al puerto/aeropuerto",
    "status.customs_clearance": "Despacho de aduana",
    "status.out_for_delivery": "En reparto",
    "status.delivered": "Entregado",
    "status.exception": "Incidente",
  },
};

export const LANG_META = {
  fr: { label: "Français", flag: "🇫🇷" },
  en: { label: "English", flag: "🇬🇧" },
  zh: { label: "中文", flag: "🇨🇳" },
  ar: { label: "العربية", flag: "🇸🇦", dir: "rtl" },
  es: { label: "Español", flag: "🇪🇸" },
};

export const DEFAULT_LANG = "fr";
